{
  "nav": {
    "dashboard": "Panel",
    "teacherDashboard": "Panel del formador",
    "projects": "Proyectos",
    "fairQuote": "Presupuesto rápido",
    "exitFairQuote": "Salir del presupuesto rápido",
    "calendar": "Calendario",
    "products": "Productos",
    "colors": "Colores",
    "company": "Empresa",
    "contacts": "Contactos",
    "applicatorProfiles": "Aplicadores",
    "courses": "Cursos",
    "certifications": "Certificaciones",
    "certificationDefinitions": "Definiciones de certificación",
    "userManagement": "Gestión de usuarios",
    "switchEntity": "Cambiar de entidad",
    "entities": "Entidades",
    "staff": "Personal",
    "overview": "Resumen",
    "sections": {
      "projects": "Proyectos",
      "shop": "Tienda",
      "learning": "Formación",
      "admin": "Administración",
      "entity": "Entidad"
    }
  },
  "materialTracking": {
    "title": "Pedido de materiales",
    "status": {
      "Draft": "Por pedir",
      "Ordered": "Pedido",
      "PartiallyDelivered": "Entregado parcialmente",
      "Delivered": "Entregado"
    },
    "statusLate": "Entrega retrasada",
    "late": "RETRASADO",
    "markOrdered": "Marcar como pedido",
    "markOrderedTitle": "Confirmar pedido",
    "markOrderedHint": "Registra que el material ha sido pedido. Opcionalmente puedes indicar una fecha de entrega estimada.",
    "estimatedDelivery": "Fecha de entrega estimada",
    "estimatedDeliveryPlaceholder": "Elegir una fecha",
    "orderedOn": "Pedido el",
    "validateDelivery": "Validar entrega",
    "addDeliveryTitle": "Registrar entrega",
    "addDeliveryHint": "Comprueba lo que se recibió realmente. Ajusta las cantidades si es necesario y añade o elimina artículos.",
    "deliveryComplete": "Entrega completa",
    "deliveryPartial": "Entrega parcial",
    "deliveries": "Entregas",
    "noLines": "Ningún artículo registrado",
    "addLine": "Añadir artículo",
    "confirmDelivery": "Guardar entrega",
    "deleteDeliveryTitle": "Eliminar entrega",
    "deleteDeliveryConfirm": "¿Seguro que deseas eliminar este registro de entrega?",
    "addStock": "Añadir stock",
    "addStockTitle": "Añadir stock manual",
    "manualStock": "Stock manual",
    "stockDescription": "descripción",
    "stockDescriptionPlaceholder": "p.ej. Saco de una obra anterior",
    "stockNotesPlaceholder": "p.ej. De Villa Martín",
    "deleteStockTitle": "Eliminar entrada de stock",
    "deleteStockConfirm": "¿Seguro que deseas eliminar esta entrada de stock?",
    "productName": "Producto",
    "quantity": "Cant.",
    "unit": "unidad",
    "unitPlaceholder": "p.ej. saco de 25 kg",
    "notes": "notas",
    "notesPlaceholder": "Nota opcional",
    "deliveryNotesPlaceholder": "p.ej. Artículos dañados, artículos faltantes",
    "confirmOrder": "Confirmar pedido",
    "draftHint": "Aún no se ha registrado ningún pedido. Haz clic en «Marcar como pedido» una vez que hayas realizado el pedido.",
    "productList": "Productos a pedir",
    "order": "Pedir",
    "orderOnShopify": "Pedir en masmaya.com",
    "orderAlerts": "Alertas de pedido",
    "daysLate": "{{count}} día de retraso",
    "daysLate_other": "{{count}} días de retraso",
    "consumption": "Necesidades de materiales",
    "sectionOrderWarningTitle": "Pedido solo para esta sección",
    "sectionOrderWarningBody": "Pedir solo para esta sección puede salir más caro que para todo el proyecto: el proyecto completo a veces alcanza umbrales de cantidad (sacos de 300 kg o 1000 kg) que una sola sección no puede alcanzar, sobre todo si el acceso a la obra permite esos formatos grandes. Considera revisar el total del proyecto antes de pedir.",
    "sectionOrderWarningConfirm": "Pedir de todos modos"
  },
  "assignedPeople": {
    "add": "Añadir persona",
    "search": "buscar…",
    "noResults": "Sin resultados",
    "replace": "Reemplazar",
    "remove": "Quitar"
  },
  "common": {
    "login": "iniciar sesión",
    "error": "Se produjo un error",
    "goHome": "Ir al inicio",
    "loading": "cargando...",
    "cancel": "cancelar",
    "create": "Crear",
    "save": "guardar",
    "edit": "editar",
    "remove": "Quitar",
    "archive": "Archivar",
    "delete": "eliminar",
    "open": "Abrir",
    "add": "añadir",
    "close": "cerrar",
    "zoom": "Zoom",
    "back": "Volver",
    "rename": "Cambiar nombre",
    "unsavedChanges": "Cambios sin guardar",
    "discardChangesTitle": "¿Descartar los cambios?",
    "discardChangesConfirm": "Tienes cambios sin guardar. ¿Seguro que quieres descartarlos?",
    "discardChangesAction": "Descartar",
    "view": "Ver",
    "search": "Buscar…",
    "tooManyResults": "Demasiados resultados, refine su búsqueda",
    "notFound": "No encontrado",
    "next": "Siguiente",
    "confirm": "Confirmar",
    "selectAll": "Seleccionar todo",
    "deselectAll": "Deseleccionar todo",
    "change": "Editar",
    "total": "Total"
  },
  "user": {
    "profile": "Perfil",
    "logout": "Cerrar sesión",
    "noEntity": "Ninguna entidad seleccionada"
  },
  "products": {
    "title": "Productos",
    "createButton": "Nuevo producto",
    "createTitle": "Crear producto",
    "editTitle": "Editar producto",
    "importButton": "Importar CSV",
    "shopifySync": {
      "button": "Sincronizar desde Shopify",
      "successTitle": "Sincronización Shopify completada",
      "successMessage": "{{updated}} productos actualizados, {{created}} creados",
      "error": "Error en la sincronización de Shopify"
    },
    "searchPlaceholder": "Buscar por nombre, variante o categoría...",
    "allCategories": "Todas las categorías",
    "excludeSamples": "Excluir muestras",
    "noData": "No se encontraron productos",
    "grouped": "Agrupado",
    "table": "Tabla",
    "columns": {
      "category": "Categoría",
      "name": "nombre",
      "variant": "Variante",
      "color": "Color",
      "sizeWeight": "Tamaño / Peso",
      "dimensions": "Dimensiones",
      "price": "precio (EUR)"
    },
    "form": {
      "category": "Categoría",
      "categoryRequired": "La categoría es obligatoria",
      "name": "Nombre del producto",
      "nameRequired": "El nombre es obligatorio",
      "variant": "Variante",
      "variantRequired": "La variante es obligatoria",
      "color": "Color",
      "sizeWeight": "Tamaño / Peso",
      "dimensions": "Dimensiones",
      "price": "precio (EUR)",
      "priceRequired": "El precio debe ser 0 o mayor",
      "sku": "SKU",
      "imageUrl": "URL de la imagen",
      "shopifyVariantId": "ID de variante de Shopify"
    },
    "delete": {
      "title": "Eliminar producto",
      "confirm": "¿Seguro que deseas eliminar «{{name}}»? Esta acción no se puede deshacer."
    },
    "import": {
      "title": "Importar productos desde CSV",
      "description": "Sube un archivo separado por tabulaciones (.csv / .tsv) con las siguientes columnas:",
      "selectFile": "Elegir archivo",
      "action": "Importar",
      "success": "Importación exitosa",
      "imported": "{{count}} productos importados.",
      "close": "cerrar"
    },
    "backToList": "Volver a productos"
  },
  "language": {
    "label": "Idioma",
    "en": "Inglés",
    "fr": "Francés",
    "de": "Alemán"
  },
  "pages": {
    "login": {
      "pageTitle": "Iniciar sesión"
    },
    "notFound": {
      "message": "Página no encontrada",
      "title": "Ups"
    },
    "milestones": {
      "pageTitle": "Hitos"
    },
    "staff": {
      "pageTitle": "Personal"
    },
    "taskGeneration": {
      "pageTitle": "Generación de tareas"
    },
    "quote": {
      "pageTitle": "Presupuesto"
    },
    "roomCalculation": {
      "pageTitle": "Cálculo de habitación"
    },
    "company": {
      "pageTitle": "Empresa"
    },
    "entityDetail": {
      "pageTitle": "Detalle de la entidad"
    },
    "entities": {
      "pageTitle": "Entidades"
    }
  },
  "projects": {
    "title": "proyectos",
    "createButton": "nuevo proyecto",
    "createTitle": "Crear proyecto",
    "editTitle": "editar proyecto",
    "searchPlaceholder": "Buscar por nombre...",
    "allStatuses": "Todos los estados",
    "noData": "No se encontraron proyectos",
    "late": "Atrasado",
    "noClient": "Sin cliente asignado",
    "presentationMode": {
      "enter": "Activar el modo presentación (oculta precios y notas internas)",
      "exit": "Salir del modo presentación"
    },
    "tracking": {
      "title": "Seguimiento"
    },
    "sequenceGenerator": {
      "title": "Generar secuencia de tareas",
      "description": "Genera automáticamente una secuencia de tareas Mas Maya planificada para una sección del proyecto.",
      "sectionLabel": "Sección",
      "startDateLabel": "Fecha de inicio",
      "generatingPreview": "Generando vista previa…",
      "generatedSequence": "Secuencia generada",
      "steps": "etapas",
      "calendarDays": "días calendario",
      "work": "trabajo",
      "dry": "secado",
      "cure": "curado",
      "generationFailed": "Error en la generación",
      "unexpectedError": "Se produjo un error inesperado. Por favor, inténtalo de nuevo.",
      "confirmAndGenerate": "Confirmar y generar",
      "createStepsAndTasks": "Crear etapas y tareas",
      "cancel": "Cancelar",
      "premiumFinish": "Acabado Premium",
      "repair": "Reparación",
      "highTraffic": "Alto tráfico",
      "confirmMessage": "Esto creará <1>{{stepCount}} etapas de proyecto</1> y <2>{{taskCount}} tareas</2> en el proyecto. Las etapas y tareas existentes no serán eliminadas.",
      "taskCount_one": "{{count}} tarea",
      "taskCount_other": "{{count}} tareas",
      "photoLabel": "{{count}}+ fotos",
      "stepTypes": {
        "SubstratePreparation": "Preparación del soporte",
        "PrimerApplication": "Aplicación de imprimación",
        "BaseLayer": "Capa base",
        "MeshInstallation": "Instalación de malla",
        "FinishingCoat": "Capa de acabado",
        "Smoothing": "Alisado",
        "Presealer": "Presealer",
        "Sealer": "Sealer",
        "HeavyDutySealer": "Heavy-Duty Sealer",
        "CuringStep": "Período de curado",
        "ProtectionPeriod": "Período de protección",
        "Handover": "Entrega al cliente"
      }
    },
    "columns": {
      "name": "nombre",
      "status": "estado",
      "manager": "Responsable",
      "entity": "Entidad",
      "startDate": "inicio",
      "endDate": "fin"
    },
    "status": {
      "Draft": "Borrador",
      "Planned": "Planificado",
      "InProgress": "En progreso",
      "OnHold": "En espera",
      "Completed": "Completado",
      "Archived": "Archivado",
      "AwaitingDelivery": "Esperando entrega",
      "Blocked": "Bloqueado",
      "AwaitingValidation": "Esperando validación",
      "CorrectionRequired": "Corrección requerida"
    },
    "executionMode": {
      "ExternalOnly": "Proyecto DIY",
      "MasMayaManaged": "Mas Maya Certified Applicator",
      "MasMayaExecuted": "Mas Maya Executed",
      "ExternalOnlyDescription": "El cliente realiza los trabajos por su cuenta",
      "MasMayaExecutedDescription": "Realizado por los equipos Mas Maya",
      "MasMayaManagedDescription": "Aplicador certificado Mas Maya"
    },
    "applicators": {
      "title": "Equipo de aplicadores",
      "selectLabel": "Añadir aplicador",
      "selectPlaceholder": "Buscar aplicadores internos...",
      "assign": "Asignar",
      "empty": "Aún no hay aplicadores asignados — usa el selector de arriba para añadir uno.",
      "requiresDates": "Defina las fechas de inicio y fin planificadas del proyecto antes de asignar aplicadores.",
      "removeTitle": "Retirar aplicador",
      "removeConfirm": "¿Retirar a {{name}} del equipo de aplicadores?"
    },
    "sections": {
      "general": "Información general",
      "contact": "Contacto principal",
      "documents": "Documentos"
    },
    "form": {
      "name": "nombre",
      "nameRequired": "El nombre es obligatorio",
      "entity": "Entidad",
      "entityRequired": "La entidad es obligatoria",
      "manager": "Jefe de proyecto",
      "managerRequired": "El jefe de proyecto es obligatorio",
      "managerPlaceholder": "Buscar un usuario...",
      "managerNoResults": "No se encontraron usuarios",
      "status": "estado",
      "date": "Fecha",
      "startTime": "Hora de inicio",
      "endTime": "Hora de fin",
      "startDate": "Fecha de inicio",
      "endDate": "Fecha de fin",
      "endDateNoSections": "Aún no hay secciones",
      "endDateCalculating": "Calculando...",
      "surface": "Superficie total (m²)",
      "description": "descripción",
      "notes": "notas",
      "primaryContact": "Contacto principal",
      "primaryContactPlaceholder": "Buscar un contacto...",
      "primaryContactNoResults": "No se encontraron contactos",
      "primaryContactClear": "— Quitar contacto",
      "executionMode": "Modo de ejecución",
      "addressLine1": "Dirección",
      "city": "Ciudad",
      "country": "País",
      "countryRequired": "El país es obligatorio",
      "namePlaceholder": "Residencia Los Pinos, Villa García...",
      "projectTypeSubtitle": "¿Qué tipo de obra es?",
      "projectTypeTitle": "Tipo de proyecto",
      "sectionSourceSubtitle": "Siempre podrá añadir o importar más secciones más tarde.",
      "sectionSourceTitle": "¿Cómo desea crear las secciones?"
    },
    "delete": {
      "title": "Eliminar proyecto",
      "confirm": "¿Seguro que deseas eliminar «{{name}}»? Esta acción no se puede deshacer.",
      "action": "eliminar"
    },
    "documents": {
      "dropzoneTitle": "Suelta los archivos aquí o haz clic para subir",
      "dropzoneHint": "Cualquier tipo de archivo aceptado",
      "preview": "Vista previa",
      "previewUnavailable": "Vista previa no disponible para este tipo de archivo",
      "download": "Descargar",
      "rename": "Renombrar",
      "removeTitle": "Eliminar documento",
      "removeConfirm": "¿Quitar «{{name}}» de este proyecto?"
    },
    "resources": {
      "title": "Recursos",
      "professionalContacts": "Contactos profesionales",
      "addTitle": "Añadir un recurso",
      "email": "correo",
      "emailPlaceholder": "nombre@example.com",
      "displayName": "Nombre y apellidos",
      "displayNamePlaceholder": "Juan Pérez",
      "role": "Rol",
      "removeTitle": "Eliminar recurso",
      "removeConfirm": "¿Quitar a {{name}} de este proyecto?",
      "columns": {
        "name": "nombre",
        "email": "correo",
        "role": "Rol",
        "linked": "Cuenta"
      },
      "empty": "Aún no hay miembros del equipo — añade uno abajo.",
      "linked": "Vinculado",
      "pending": "Pendiente",
      "roles": {
        "PM": "Jefe de proyecto",
        "Worker": "Operario",
        "QualityManager": "Responsable de calidad"
      },
      "noAvailable": "Ninguna persona disponible para asignar",
      "certifiedGroup": "Aplicadores certificados",
      "selectCertifiedCompanies": "Empresas con aplicador certificado"
    },
    "projectSections": {
      "title": "Secciones",
      "createTitle": "Añadir una sección",
      "editTitle": "Editar sección",
      "add": "Añadir sección",
      "empty": "Aún no hay secciones",
      "wet": "Húmedo",
      "submerged": "Sumergido",
      "protected": "Protegido",
      "exterior": "Exterior",
      "renameFloor": "Renombrar planta",
      "deleteTitle": "Eliminar sección",
      "deleteConfirm": "¿Eliminar la sección «{{label}}»? Esta acción no se puede deshacer.",
      "columns": {
        "label": "Etiqueta",
        "color": "Color",
        "type": "Tipo",
        "surface": "Superficie",
        "finish": "Acabado",
        "surfaceM2": "Área",
        "flags": "Opciones",
        "workers": "Operarios"
      },
      "stepProgress": "Paso {{current}} de {{total}}"
    },
    "sectionForm": {
      "label": "Etiqueta",
      "color": "Color",
      "colorPlaceholder": "Buscar un color...",
      "colorClear": "— Quitar el color",
      "colorNoResults": "No se encontraron colores",
      "type": "Tipo",
      "roomSubtype": "Subtipo",
      "substrate": "Soporte",
      "finish": "Acabado",
      "surfaceM2": "Superficie (m²)",
      "exposure": "Exposición",
      "condition": "Estado del soporte",
      "traffic": "Tráfico",
      "insideCornerLinearM": "Ángulos entrantes (ml)",
      "insideCornerHint": "No doblar la malla en los ángulos entrantes",
      "outsideCornerLinearM": "Ángulos salientes (ml)",
      "outsideCornerHint": "Malla envuelta 10 cm a cada lado",
      "isCurved": "Superficie curva",
      "isCurvedHint": "Bóveda, columna, arco (+15 % de merma)",
      "isRepair": "Reparación / pequeño retoque",
      "isRepairHint": "Cantidades mínimas a tanto alzado",
      "repairForfaitBadge": "A tanto alzado",
      "workers": "Operarios asignados",
      "workersPlaceholder": "Seleccionar operarios...",
      "quantityPreview": "Vista previa de cantidades",
      "layerCount": "capa(s)",
      "meshForcedNotice": "La malla es obligatoria para este tipo de superficie — no se puede desactivar",
      "waterproofMembrane": "Membrana impermeabilizante",
      "waterproofConfirmed": "Presente y confirmada",
      "waterproofAbsent": "Ausente o sin verificar",
      "waterproofUnknown": "Seleccionar...",
      "waterproofExplanation": "Mas Maya es un revestimiento resistente al agua, no un sistema de impermeabilización. Es obligatorio instalar una membrana impermeabilizante (p. ej. Schlüter-KERDI, Aqua-Panel) antes de aplicar en zonas húmedas.",
      "waterproofBlockingWarning": "No se puede guardar: se requiere una membrana impermeabilizante confirmada para las zonas húmedas.",
      "waterproofToPose": "Membrana a instalar",
      "waterproofWillBeAdded": "Sin membrana presente — se añadirán la membrana y los refuerzos de esquina/traspaso de tubería al carrito de materiales.",
      "insideCornerCount": "Número de esquinas entrantes",
      "insideCornerCountHint": "Número de refuerzos de esquina entrante a instalar (ej. 4 para una piscina rectangular)",
      "outsideCornerCount": "Número de esquinas salientes",
      "outsideCornerCountHint": "Número de refuerzos de esquina saliente a instalar",
      "pipePenetrationCount": "Número de traspasos de tubería",
      "pipePenetrationCountHint": "Número de refuerzos de traspaso de tubería a instalar",
      "system": {
        "standard1Layer": "Seco — 1 capa",
        "premium2Layers": "Seco — 2 capas",
        "mesh2Layers": "Malla — 2 capas",
        "pool": "Piscina — Sistema crítico",
        "exterior": "Exterior — Fachada",
        "exteriorFloor": "Exterior — Suelo / Terraza"
      },
      "riskLevel": {
        "low": "Riesgo bajo",
        "medium": "Riesgo moderado",
        "high": "Riesgo alto",
        "very-high": "Riesgo muy alto",
        "critical": "Riesgo crítico"
      },
      "warnings": {
        "deterioratedSupport": "Soporte deteriorado — Preparación obligatoria",
        "tilesAlwaysMesh": "Azulejo existente — Preparación + malla obligatorias (movimiento de juntas)",
        "floorMesh": "Suelo — Malla + Presealer + Sealer obligatorios",
        "stepsMeshNosing": "Escaleras — Malla envuelta sobre el borde del peldaño, Presealer + Sealer incluidos",
        "brickBlockMesh": "Soporte con juntas — Malla obligatoria",
        "plasterboardMovement": "Pladur / tabique — Riesgo de movimiento, malla obligatoria",
        "wetZone": "Baño (sin contacto directo con agua) — Malla + protección obligatorias",
        "directWaterZone": "Contacto directo con agua — Primer de piscina seleccionado automáticamente",
        "waterproofMembraneRequired": "Membrana impermeabilizante obligatoria — debe confirmarse antes de la aplicación",
        "masMayaWaterResistant": "Mas Maya es resistente al agua pero no impermeable — es obligatoria una membrana previa",
        "submergedZone": "Zona sumergida — Primer de piscina + malla",
        "exteriorExposure": "Exposición exterior — protección UV obligatoria",
        "sealingRequired": "Protección solicitada — Presealer + Sealer incluidos",
        "heavyDutyRecommended": "Se recomienda Heavy-Duty Sealer para este tipo de superficie",
        "poolWaterproofMembrane": "Piscina — Membrana impermeabilizante obligatoria antes del Primer de piscina",
        "poolWaterline": "Heavy-Duty Sealer obligatorio en la línea de flotación (±20 cm)",
        "poolAftercare3Weeks": "Idealmente esperar 3 semanas antes de llenar la piscina",
        "exteriorFacadeMesh": "Fachada exterior — Malla + Presealer + Sealer obligatorios",
        "drainageSlopeWarning": "Comprobar la pendiente (mín. 1,5 %) y el drenaje antes de aplicar",
        "exteriorHeavyDuty": "Suelo exterior — Heavy-Duty Sealer obligatorio (resistencia UV + tráfico)",
        "curingTime72h": "Tiempo de curado final: mínimo 72h tras la última capa de sealer",
        "furnitureMesh": "Madera / MDF — Riesgo de movimiento, malla obligatoria",
        "insideCornerNoFold": "Ángulos entrantes — No doblar la malla, cortar y solapar las tiras",
        "outsideCornerMesh": "Ángulos salientes — Malla envuelta 10 cm a cada lado (+0,20 m²/ml)",
        "curvedSurfaceFactor": "Superficie curva — +15 % de merma de coating y malla aplicada",
        "repairForfait": "Reparación — Cantidades mínimas a tanto alzado aplicadas"
      },
      "types": {
        "Wall": "Pared",
        "Pool": "Piscina",
        "Facade": "Fachada",
        "Steps": "Escaleras",
        "Furniture": "Mobiliario / Empotrado",
        "Room": "Habitación"
      },
      "typeDescriptions": {
        "Room": "Habitación con suelo, paredes y techo",
        "Wall": "Superficie de pared interior",
        "Pool": "Piscina o cuenca sumergida",
        "Facade": "Fachada exterior",
        "Steps": "Escaleras o peldaños",
        "Furniture": "Mobiliario, armario u objeto"
      },
      "roomSubtypes": {
        "Bathroom": "Baño",
        "Default": "Estándar"
      },
      "substrates": {
        "Tiles": "Azulejo",
        "Concrete": "Hormigón",
        "Wood": "Madera",
        "Brick": "Ladrillo",
        "Block": "Bloque de hormigón",
        "Plasterboard": "Pladur / tabique"
      },
      "finishes": {
        "Standard": "Estándar",
        "Premium": "Premium"
      },
      "protectionLevels": {
        "None": "Ninguna",
        "Presealer": "Solo presellador",
        "PresealerSealer": "Presellador + sellador acrílico",
        "PresealerHeavyDutySealer": "Presellador + sellador de alta resistencia"
      },
      "exposures": {
        "None": "Ninguna",
        "Wet": "Sala húmeda (baño — sin contacto directo con agua)",
        "DirectWater": "Contacto directo con agua (ducha / lavabo / bañera)",
        "Submerged": "Sumergido (piscina / fuente)",
        "Outside": "Exterior",
        "WaterProtected": "Protección al agua (petición del cliente)",
        "SolvantProtected": "Protección a disolventes Heavy-Duty"
      },
      "conditions": {
        "New": "Nuevo",
        "Good": "Buen estado",
        "Normal": "Normal",
        "Deteriorated": "Deteriorado (preparación obligatoria)"
      },
      "trafficLevels": {
        "None": "Ninguno",
        "Low": "Bajo",
        "Medium": "Medio",
        "High": "Alto"
      },
      "typeChangeReset": "Algunos campos fueron restablecidos porque no son compatibles con este tipo de sección.",
      "underfloorHeating": "Calefacción por suelo radiante",
      "underfloorHeatingPlaceholder": "No especificado",
      "underfloorHeatingYes": "Sí — calefacción por suelo radiante presente",
      "underfloorHeatingNo": "No — sin calefacción por suelo radiante",
      "underfloorHeatingType": "Tipo de calefacción",
      "underfloorHeatingUnknown": "Tipo desconocido",
      "underfloorHeatingWater": "Agua caliente",
      "underfloorHeatingElectric": "Eléctrico",
      "isExteriorRoom": "Exterior",
      "isExteriorRoomHint": "La habitación está expuesta al exterior",
      "isFurnishedRoom": "Habitación amueblada",
      "isFurnishedRoomHint": "Contiene muebles que proteger",
      "isOccupiedSite": "Obra ocupada",
      "isOccupiedSiteHint": "La obra está ocupada durante los trabajos",
      "coatCeiling": "Techo",
      "coatFloor": "Suelo",
      "coatWalls": "Paredes",
      "includedSurfaces": "Superficies incluidas",
      "roomBreakdown": {
        "ceilingM2": "Techo calculado",
        "floorM2": "Suelo calculado",
        "heightCoefficient": "Coeficiente de altura",
        "heightM": "Altura",
        "noRoomParams": "Configuración de cálculo no disponible",
        "placeholderHeightWarning": "Altura no indicada — 2,5 m utilizado temporalmente para el cálculo",
        "surfaceM2": "Superficie de la sala",
        "totalM2": "Total calculado:",
        "wallsM2": "Paredes calculadas"
      },
      "roomHeightM": "Altura (m)",
      "roomHeightPlaceholder": "Altura no indicada — 2,5 m utilizado por defecto para los cálculos",
      "roomLengthM": "Longitud (m)",
      "roomWidthM": "Anchura (m)",
      "selectFinish": "Seleccionar acabado...",
      "selectSubstrate": "Seleccionar soporte...",
      "surface": {
        "ceiling": "Techo",
        "floor": "Suelo",
        "walls": "Paredes"
      },
      "surfaceConfig": "Configuración por superficie",
      "steps": {
        "identity": "Identidad",
        "type": "Tipo",
        "parameters": "Parámetros",
        "validation": "Validación"
      },
      "identityTitle": "Identidad de la sección",
      "identitySubtitle": "Nombre esta sección y asocie un color Mas Maya.",
      "typeTitle": "Tipo de sección",
      "typeSubtitle": "¿Qué tipo de superficie desea configurar?",
      "roomConfigTitle": "Configuración de la habitación",
      "roomConfigSubtitle": "Introduzca las dimensiones y las superficies a tratar.",
      "standardConfigSubtitle": "Introduzca las características técnicas de esta superficie.",
      "summaryTitle": "Resumen",
      "summarySubtitle": "Compruebe la información antes de crear la sección.",
      "colorModes": {
        "SingleColor": "Color único",
        "PerSurface": "Color por superficie"
      },
      "colorPerSurfaceHint": "Elija un color para cada superficie en el paso Parámetros.",
      "subtypeLabel": "Subtipo de habitación",
      "subtypes": {
        "Default": {
          "label": "Estándar",
          "description": "Habitación sin configuración específica"
        },
        "Bathroom": {
          "label": "Baño",
          "description": "Acabado Premium + exposición DirectWater impuesta"
        },
        "Kitchen": {
          "label": "Cocina",
          "description": "Próximamente"
        },
        "Bedroom": {
          "label": "Dormitorio",
          "description": "Próximamente"
        },
        "SpaHammam": {
          "label": "Spa / Hammam",
          "description": "Próximamente"
        }
      },
      "comingSoon": "Próximamente",
      "floorColorLabel": "Color suelo",
      "wallsColorLabel": "Color paredes",
      "ceilingColorLabel": "Color techo",
      "createSection": "Crear sección",
      "selectColorPlaceholder": "Elegir un color…",
      "labelPlaceholderRoom": "ej. Salón principal, Baño planta alta…",
      "surfacesToTreat": "Superficies a tratar",
      "siteCharacteristics": "Características de la obra",
      "createdTitle": "Sección creada"
    },
    "consumption": {
      "title": "Consumo de productos",
      "projectTotal": "Total del proyecto",
      "perSection": "Detalle por sección"
    },
    "materials": {
      "title": "Pedido de materiales",
      "projectTotal": "Lista de compra",
      "perSection": "Detalle por sección",
      "product": "Producto",
      "qty": "Cant.",
      "cost": "Coste",
      "noProducts": "No hay productos que mostrar",
      "noSections": "Aún no hay secciones — añade una sección en la pestaña Secciones para ver los materiales necesarios.",
      "productNotFound": "No se encontró ningún producto coincidente en el catálogo",
      "orderOnShopify": "Pedir en masmaya.com",
      "largeVolumeActive": "Acceso a gran volumen activo",
      "largeVolumeActiveDesc": "Se incluyen sacos de 300 kg y 1000 kg. Si esta obra no acepta entregas en palé, desactiva el acceso a gran volumen en los ajustes del proyecto.",
      "limitedAccess": "Acceso limitado — solo se ofrecen envases pequeños.",
      "line": {
        "prep": "Mas Maya Prep",
        "poolPrimer": "Mas Maya Pool Primer",
        "primer": "Mas Maya Primer",
        "coating1Layer": "Mas Maya Coating (1 capa)",
        "coating2Layer": "Mas Maya Coating (2 capas)",
        "mixingWater": "Agua de amasado",
        "mesh": "Mas Maya Mesh",
        "presealer": "Mas Maya Presealer",
        "sealer": "Mas Maya Sealer",
        "heavyDutySealer": "Mas Maya Heavy-Duty Sealer",
        "waterproofMembrane": "Waterproof Membrane",
        "waterproofCornerReinforcement": "Waterproof Corner Reinforcement",
        "waterproofPipeReinforcement": "Waterproof Pipe Reinforcement",
        "pigment": "Pigmento {{name}}"
      }
    },
    "quote": {
      "title": "Propuesta comercial",
      "breakdown": "Desglose detallado",
      "copyText": "Copiar como texto",
      "copied": "¡Copiado!",
      "materials": "Materiales",
      "labour": "Mano de obra",
      "recipientEmail": "Email del destinatario",
      "downloadPdf": "Descargar en PDF",
      "sendByEmail": "Enviar por email",
      "provisionalDimensionsWarning": "Una o más secciones utilizan una altura de habitación provisional (no confirmada). Las cantidades y el coste mostrados son indicativos — el envío por email y la creación de un presupuesto Holded están desactivados hasta que se indique la altura real en la sección.",
      "provisionalBadge": "Provisional",
      "pdfError": "Error al generar el PDF",
      "emailSuccess": "Propuesta comercial enviada por email a {{email}}",
      "emailError": "Error al enviar la propuesta comercial por email",
      "showPreview": "Ver la propuesta comercial",
      "client": "Cliente",
      "project": "Proyecto",
      "totalSurface": "Superficie total: {{surface}} m²",
      "sectionsProgress": "Secciones: {{done}} / {{total}} terminadas",
      "estimatedTime": "Tiempo estimado: {{hours}} h",
      "totalEstimated": "Total estimado",
      "disclaimer": "Esta propuesta comercial es indicativa y se basa en los datos introducidos en el proyecto; puede ajustarse tras una visita técnica.",
      "sectionsHeading": "Detalle por sección",
      "whyTitle": "¿Por qué elegir Mas Maya?",
      "whyIntro": "Especialista en impermeabilización y revestimientos decorativos para piscinas, baños y fachadas, Mas Maya diseña sistemas duraderos, estéticos y fáciles de mantener.",
      "whyPoint1Title": "Red de aplicadores certificados",
      "whyPoint1Text": "Una instalación garantizada por profesionales formados y certificados por Mas Maya, en toda Francia.",
      "whyPoint2Title": "Acabados premium",
      "whyPoint2Text": "Resultados cuidados y una amplia paleta de colores, pensados para durar en el tiempo.",
      "whyPoint3Title": "Un acompañamiento a medida",
      "whyPoint3Text": "DIY, aplicador certificado o realización llave en mano por nuestros equipos: usted elige su nivel de acompañamiento.",
      "addSectionToCart": "Añadir al carrito Mas Maya",
      "addProjectToCart": "Añadir todo el proyecto al carrito Mas Maya",
      "timeline": "Plazos de aplicación",
      "totals": "Totales del proyecto",
      "rawHours": "Horas brutas",
      "adjustedHours": "Horas ajustadas",
      "totalRawHours": "Total de horas brutas",
      "totalHours": "Total de horas (ajustado)",
      "noSections": "No hay secciones con datos para presupuestar.",
      "textHeader": "PRESUPUESTO — {{name}}",
      "textSection": "Sección",
      "complexityLevel": {
        "low": "Complejidad baja",
        "normal": "Estándar",
        "medium": "Complejidad media",
        "high": "Complejidad alta"
      },
      "tasks": {
        "prep": "Preparación",
        "primer": "Primer",
        "coating": "Aplicación de coating",
        "smoothing": "Alisado / pulido",
        "presealer": "Presealer",
        "sealer": "Sealer",
        "heavyDutySealer": "Heavy-Duty Sealer"
      },
      "timelineSteps": {
        "afterPrep": "Después de la preparación",
        "afterPrimer": "Después del primer",
        "betweenLayers": "Entre capas",
        "afterSmoothing": "Después del alisado",
        "afterPresealer": "Después del presealer",
        "afterSealer": "Después del sealer",
        "afterHeavyDutySealer": "Después del Heavy-Duty Sealer",
        "poolFill": "Antes de llenar la piscina"
      }
    },
    "workflow": {
      "title": "Estado del trabajo",
      "notes": "notas",
      "notesPlaceholder": "Añadir una nota...",
      "photos": "Fotos",
      "addPhotos": "Añadir fotos",
      "photoRequired": "Se requiere al menos una foto",
      "history": "Historial",
      "approved": "Calidad aprobada",
      "status": {
        "InProgress": "En curso",
        "WorkerDone": "Trabajo terminado",
        "QualityApproved": "Aprobado"
      },
      "changeType": {
        "WorkerDone": "Trabajo terminado",
        "QualityApproved": "Aprobado",
        "QualitySkipped": "Control omitido",
        "QualityRejected": "Rechazado"
      },
      "workerDone": {
        "title": "Marcar como terminado",
        "description": "Sube al menos una foto para confirmar que el trabajo está terminado.",
        "action": "Marcar como terminado",
        "submit": "Confirmar terminado"
      },
      "quality": {
        "title": "Control de calidad",
        "description": "Revisa la sección y aprueba o rechaza el trabajo.",
        "action": "Control de calidad",
        "approve": "Aprobar",
        "reject": "Rechazar",
        "skipCheck": "Omitir el control de calidad (sin inspección necesaria)"
      }
    },
    "cards": {
      "sections": "{{done}} / {{total}} secciones aprobadas",
      "totalProject": "Total proyecto",
      "labour": "Mano de obra",
      "materials": "Materiales",
      "incompleteCalc": "Cálculo incompleto",
      "materialsShort": "Mat.",
      "labourShort": "M.O."
    },
    "sectionAttrs": {
      "characteristics": "Características",
      "conditions": "Condiciones de uso",
      "dimensions": "Superficie y geometría",
      "roomDimensions": "Dimensiones de la habitación",
      "conditionsStandard": "Condiciones estándar",
      "color": "Color",
      "noColor": "No hay color definido",
      "surfaceComputed": "Superficie calculada",
      "surfaceComputedHint": "se actualizará tras guardar",
      "surfaceUsed": "Superficie utilizada",
      "surfaceOverridden": "Superficie sobrescrita",
      "surfaceOverride": "Sobrescritura manual",
      "surfaceOverrideHint": "Dejar vacío para usar la superficie calculada",
      "surfaceOverridePlaceholder": "Superficie en m²",
      "noDimensions": "No hay dimensiones definidas",
      "roomWidth": "Ancho",
      "roomLength": "Largo",
      "roomHeight": "Altura",
      "coatWalls": "Revestir las paredes",
      "coatCeiling": "Revestir el techo",
      "coatFloor": "Revestir el suelo",
      "parameters": "Parámetros",
      "siteOccupied": "Sitio ocupado",
      "furnishedRoom": "Habitación amueblada",
      "complexityLabel": "complejidad",
      "furnishedMarkupLabel": "amueblado",
      "occupiedMarkupLabel": "ocupado",
      "standardFinishDiscountLabel": "acabado estándar",
      "editColorsHint": "Modifica los colores en Parámetros más abajo",
      "coatingSurfaceSuffix": "m² a revestir"
    },
    "bulkColor": {
      "title": "Aplicar un color a todas las secciones",
      "hint": "El color seleccionado se aplicará a las {{count}} sección(es) del proyecto.",
      "removeAll": "Quitar el color de todas las secciones",
      "confirmTitle": "Confirmar aplicación",
      "confirmApply": "¿Aplicar el color «{{color}}» a {{count}} sección(es)?",
      "confirmRemove": "¿Quitar el color de las {{count}} sección(es)?",
      "appliedMessage": "Color aplicado a las secciones seleccionadas.",
      "removedMessage": "Color eliminado de las secciones seleccionadas."
    },
    "bulkFinishProtection": {
      "title": "Acabado y protección (todo el proyecto)",
      "hint": "Estos ajustes siempre se aplican a la totalidad del proyecto — el consumo de materiales y el coste de mano de obra dependen de ellos.",
      "finishLabel": "Acabado",
      "protectionLabel": "Protección",
      "apply": "Aplicar a todo el proyecto",
      "confirmTitle": "Confirmar aplicación",
      "confirmApplyFinish": "Acabado «{{finish}}» en {{count}} sección(es).",
      "confirmApplyProtection": "Protección «{{level}}» en {{count}} sección(es).",
      "appliedMessage": "Acabado y protección aplicados a todo el proyecto."
    },
    "bulkFinish": {
      "title": "Aplicar un acabado a todo el proyecto",
      "hint": "Esto cambia el acabado de todas las secciones del proyecto — el consumo de materiales varía según el acabado.",
      "lockedSectionsHint": "{{count}} sección(es) con un acabado bloqueado (p.ej. escaleras, siempre en Premium) no se verán afectadas.",
      "confirmCheckboxLabel": "Entiendo que esto se aplica a la totalidad del proyecto",
      "apply": "Aplicar a todo el proyecto",
      "confirmTitle": "Confirmar aplicación",
      "confirmApply": "¿Aplicar el acabado «{{finish}}» a las {{count}} sección(es) del proyecto?",
      "appliedMessage": "Acabado aplicado a todo el proyecto."
    },
    "bulkProtection": {
      "title": "Aplicar un nivel de protección a todo el proyecto",
      "hint": "Esto cambia el nivel de protección (presellador / sellador) de todas las secciones elegibles del proyecto — afecta tanto al coste de materiales como al de mano de obra.",
      "lockedSectionsHint": "{{count}} sección(es) (piscinas o zonas en contacto directo/sumergido con agua) siempre conservan su protección obligatoria y no se verán afectadas. Los suelos de las habitaciones también permanecen siempre automáticos.",
      "confirmCheckboxLabel": "Entiendo que esto se aplica a la totalidad del proyecto",
      "apply": "Aplicar a todo el proyecto",
      "confirmTitle": "Confirmar aplicación",
      "confirmApply": "¿Aplicar el nivel de protección «{{level}}» a las {{count}} sección(es) del proyecto?",
      "appliedMessage": "Nivel de protección aplicado a todo el proyecto."
    },
    "bulkType": {
      "title": "Aplicar un tipo a todas las secciones",
      "hint": "El tipo seleccionado se aplicará a las {{count}} sección(es) de este piso.",
      "confirmTitle": "Confirmar aplicación",
      "confirmApply": "¿Aplicar el tipo \"{{type}}\" a {{count}} sección(es)?",
      "coatingStep": "Superficies a revestir",
      "descriptions": {
        "Room": "Habitación con suelo, paredes y techo",
        "Wall": "Superficie de pared interior",
        "Pool": "Piscina o depósito sumergido",
        "Facade": "Fachada exterior",
        "Steps": "Escaleras o borde de peldaño",
        "Furniture": "Mobiliario, armario u objeto"
      }
    },
    "bulkExclude": {
      "title": "Excluir secciones del cálculo",
      "hint": "Las secciones marcadas quedarán excluidas del cálculo de materiales y mano de obra.",
      "apply": "Aplicar",
      "selectAll": "Seleccionar todo",
      "selectNone": "Deseleccionar todo",
      "banner": "{{count}} sección(es) excluida(s) del cálculo"
    },
    "extractPlan": {
      "title": "Extraer desde un plano",
      "hint": "Sube un plano arquitectónico para extraer automáticamente las habitaciones y sus dimensiones.",
      "dropZone": "Haz clic para elegir un plano (JPG, PNG, PDF...)",
      "extract": "Analizar el plano",
      "noPlans": "No hay planos cargados. Añade imágenes o un PDF arriba.",
      "uploading": "Cargando...",
      "partialError": "{{count}} página(s) no se pudieron analizar.",
      "noRoomsFound": "No se detectaron habitaciones. Prueba con una imagen más clara.",
      "converting": "Convirtiendo PDF...",
      "extracting": "Analizando...",
      "error": "Error en el análisis. Comprueba que la imagen es legible e inténtalo de nuevo.",
      "selectHint": "{{count}} habitaciones detectadas. Selecciona las que quieras convertir en secciones.",
      "confidence": "índice de confianza",
      "heightHint": "Altura visible en el plano o a introducir manualmente",
      "applyHeightToAll": "Altura para todas las piezas",
      "createSections": "Crear {{count}} sección(es)",
      "creating": "Creando secciones...",
      "generatingTasks": "Generando tareas de seguimiento...",
      "done": "¡{{count}} sección(es) creada(s) correctamente!",
      "tasksGenerated": "{{count}} tarea(s) de seguimiento generada(s).",
      "surfaceType": "¿Qué tipo de superficie desea configurar?"
    },
    "tasks": {
      "form": {
        "title": "Título",
        "titlePlaceholder": "Título de la tarea",
        "category": "Categoría",
        "priority": "Prioridad",
        "plannedStart": "Fecha de inicio planificada",
        "plannedEnd": "Fecha de fin planificada",
        "datePlaceholder": "Seleccionar fecha",
        "tabDescription": "Descripción",
        "tabTechnical": "Nota técnica",
        "tabInternal": "Nota interna",
        "tabClient": "Nota cliente",
        "descriptionPlaceholder": "Descripción de la tarea...",
        "technicalPlaceholder": "Notas técnicas...",
        "internalPlaceholder": "Notas internas (no visibles al cliente)...",
        "clientPlaceholder": "Instrucciones para el cliente...",
        "validationRequired": "Validación requerida",
        "weatherSensitive": "Sensible al clima",
        "clientVisible": "Visible para el cliente",
        "internalOnly": "Solo interno",
        "mandatoryPhoto": "Fotos obligatorias",
        "minPhotos": "Mín. fotos",
        "create": "Crear tarea",
        "save": "Guardar",
        "cancel": "Cancelar",
        "generatedWarning": "Esta tarea fue generada automáticamente. Editarla marcará la tarea como modificada manualmente.",
        "rejectionTitle": "Asunto del rechazo",
        "rejectionTitlePlaceholder": "Ej: Textura no conforme",
        "rejectionReason": "Razón detallada",
        "rejectionReasonPlaceholder": "Ej: La zona izquierda presenta una diferencia de grano demasiado visible...",
        "confirmRejection": "Confirmar rechazo",
        "validationNotes": "Notas de validación (opcional)",
        "validationNotesPlaceholder": "Notas para el expediente...",
        "blockingType": "Tipo de bloqueo",
        "blockingTypeInternal": "Interno (materiales, planificación, equipo...)",
        "blockingTypeExternal": "Externo (otros oficios, cliente, clima...)",
        "blockingReason": "Razón del bloqueo",
        "blockingReasonHint": "Explica qué debe ocurrir para desbloquear esta tarea, para que quien lo lea sepa exactamente qué hacer."
      },
      "source": {
        "Generated": "Generada",
        "Modified": "Modificada",
        "Manual": "Manual"
      },
      "actions": {
        "title": "Acciones",
        "start": "Iniciar tarea",
        "requestReview": "Solicitar validación",
        "resubmit": "Reenviar",
        "validate": "Validar tarea",
        "reject": "Rechazar tarea",
        "unblock": "Desbloquear tarea",
        "block": "Bloquear tarea",
        "addPhotos": "Añadir fotos",
        "edit": "Editar tarea"
      },
      "status": {
        "Todo": "Por hacer",
        "Active": "En curso",
        "ReviewRequested": "En revisión",
        "Completed": "Validada",
        "CorrectionRequired": "Corrección requerida",
        "Blocked": "Bloqueada",
        "todoMessage": "Esta tarea aún no está activa. Comenzará automáticamente al validar la tarea anterior.",
        "awaitingValidation": "En espera de validación por el responsable.",
        "blockedLabel": "Bloqueada",
        "blockedWhoInternal": "{{name}} debe actuar para desbloquear esta tarea",
        "blockedWhoInternalFallback": "Tu equipo",
        "blockedWhoExternal": "Esperando una acción externa (cliente, proveedor, otro oficio)",
        "completedLabel": "Tarea validada",
        "correctionRequired": "Tarea rechazada",
        "instructions": "Instrucciones: {{instructions}}",
        "submittedPhotos": "Fotos enviadas",
        "requestReviewTitle": "Añada al menos {{count}} foto(s) antes de solicitar validación",
        "resubmitTitle": "Añada al menos {{count}} foto(s) antes de reenviar"
      },
      "photos": {
        "title": "Fotos",
        "required": "· {{current}}/{{required}} requerida(s)",
        "added": "Foto añadida",
        "uploadFailed": "Error al subir foto",
        "uploadFailedMessage": "No se puede enviar el archivo. Verifique el formato o inténtelo de nuevo."
      },
      "notifications": {
        "validated": "Tarea validada",
        "nextTaskStarted": "La siguiente tarea ha comenzado automáticamente.",
        "lastTaskValidated": "Última tarea validada.",
        "validationError": "Error",
        "validationErrorMessage": "No se puede validar la tarea.",
        "rejected": "Tarea rechazada",
        "rejectedMessage": "El trabajador ha sido notificado y puede corregir.",
        "rejectionError": "Error",
        "rejectionErrorMessage": "No se puede rechazar la tarea."
      },
      "history": "Historial",
      "deleteTask": {
        "title": "Eliminar tarea",
        "confirm": "¿Está seguro de que desea eliminar <strong>{{name}}</strong>?",
        "action": "Eliminar"
      },
      "editModal": "Editar tarea",
      "noTasksForStep": "No hay tareas para este paso.",
      "noTasksForSection": "No hay tareas generadas para esta sección.",
      "blockedMessage_one": "Complete {{count}} campo técnico para generar el flujo de trabajo: {{fields}}.",
      "blockedMessage_other": "Complete {{count}} campos técnicos para generar el flujo de trabajo: {{fields}}.",
      "blockerField": {
        "height": "altura",
        "substrate": "sustrato",
        "waterproofMembrane": "membrana impermeabilizante"
      },
      "completeConfiguration": "Completar la configuración de la sección",
      "readyToGenerate": "Esta sección está lista — el flujo de trabajo aún no se ha generado.",
      "generateNow": "Generar tareas ahora",
      "ungrouped": "Tareas sin paso",
      "taskCount_one": "{{count}} tarea",
      "taskCount_other": "{{count}} tareas",
      "completedCount_one": "{{count}} validada",
      "completedCount_other": "{{count}} validadas",
      "blockedCount_one": "{{count}} bloqueada",
      "blockedCount_other": "{{count}} bloqueadas",
      "deleteSectionTasks": {
        "title": "Eliminar todas las tareas de la sección",
        "confirm": "Eliminar {{count}} tarea(s) de la sección <strong>{{section}}</strong>? Esta acción es irreversible.",
        "action": "Eliminar todo",
        "tooltip": "Eliminar todas las tareas de esta sección"
      },
      "showPast_one": "Mostrar {{count}} tarea pasada",
      "showPast_other": "Mostrar {{count}} tareas pasadas",
      "showFuture_one": "Mostrar {{count}} tarea siguiente",
      "showFuture_other": "Mostrar {{count}} tareas siguientes",
      "hidePast": "Ocultar tareas pasadas",
      "hideFuture": "Ocultar tareas siguientes",
      "dateFrom": "A partir del {{date}}",
      "dateBefore": "Antes del {{date}}",
      "stepTypes": {
        "SubstratePreparation": "Preparación del sustrato",
        "PrimerApplication": "Aplicación de imprimación",
        "BaseLayer": "Capa base",
        "MeshInstallation": "Instalación de malla",
        "FinishingCoat": "Capa de acabado",
        "Smoothing": "Alisado",
        "Presealer": "Presealer",
        "Sealer": "Sealer",
        "HeavyDutySealer": "Sealer de alta resistencia",
        "CuringStep": "Curado",
        "ProtectionPeriod": "Período de protección",
        "Handover": "Entrega al cliente"
      },
      "sectionTypes": {
        "Wall": "Pared",
        "Floor": "Suelo",
        "Bathroom": "Baño",
        "Pool": "Piscina",
        "Facade": "Fachada",
        "Steps": "Escaleras",
        "Furniture": "Mobiliario",
        "Room": "Habitación",
        "Ceiling": "Techo"
      },
      "categories": {
        "preparation": "Preparación",
        "primer": "Imprimación",
        "mesh": "Malla",
        "base_layer": "Capa base",
        "finishing_layer": "Capa de acabado",
        "smoothing": "Alisado",
        "presealer": "Presealer",
        "sealer": "Sealer",
        "heavy_duty_sealer": "Sealer HD",
        "curing": "Curado",
        "delivery": "Entrega",
        "inspection": "Inspección",
        "handover": "Traspaso",
        "custom": "Personalizado"
      },
      "priorities": {
        "low": "Baja",
        "normal": "Normal",
        "high": "Alta",
        "critical": "Crítica"
      },
      "visualStatus": {
        "pending": "Por hacer",
        "inProgress": "En curso",
        "review": "En revisión",
        "completed": "Validado",
        "rejected": "Rechazado",
        "blocked": "Bloqueado",
        "overdue": "Atrasado"
      },
      "blockingType": {
        "Internal": "Interno",
        "External": "Externo"
      },
      "noSectionsMessage": "Cree una sección para generar automáticamente el seguimiento del proyecto.",
      "noTasksGeneratedMessage": "No se generaron tareas. Verifique los datos técnicos de sus secciones."
    },
    "projectType": {
      "Renovation": "Proyecto de renovación",
      "RenovationDescription": "Rehabilitación de superficies existentes",
      "Neuf": "Obra nueva",
      "NeufDescription": "Nueva construcción y superficies"
    },
    "sectionSource": {
      "import": "Importar planos",
      "importDescription": "Detección automática de habitaciones a partir de los planos",
      "manual": "Crear manualmente",
      "manualDescription": "Defina sus secciones una por una"
    },
    "wizard": {
      "steps": {
        "project": "Proyecto",
        "mode": "Modo",
        "type": "Tipo",
        "logistics": "Logística"
      },
      "step1": {
        "title": "Nuevo proyecto",
        "subtitle": "Rellene la información básica para crear su proyecto."
      },
      "step2": {
        "title": "Modo de ejecución",
        "subtitle": "¿Cómo se ejecutará este proyecto?"
      },
      "step3": {
        "title": "Tipo de proyecto",
        "subtitle": "¿Cuál es el contexto de este proyecto?"
      },
      "step4": {
        "title": "Acceso a la obra",
        "subtitle": "¿Son posibles las entregas en palé en esta obra?"
      },
      "modes": {
        "ExternalOnly": {
          "label": "Proyecto DIY",
          "description": "El cliente gestiona la ejecución con la información proporcionada."
        },
        "MasMayaManaged": {
          "label": "Aplicador certificado",
          "description": "Proyecto confiado a un aplicador certificado Mas Maya."
        },
        "MasMayaExecuted": {
          "label": "Ejecutado por Mas Maya",
          "description": "Proyecto ejecutado directamente por los equipos Mas Maya."
        }
      },
      "types": {
        "Renovation": {
          "label": "Renovación",
          "description": "Soporte existente, estado a evaluar."
        },
        "Neuf": {
          "label": "Obra nueva",
          "description": "Soporte nuevo, parámetros pre-rellenados."
        }
      },
      "access": {
        "large": {
          "label": "Acceso gran volumen",
          "description": "Entregas en palé, contenedores de 300 kg y 1000 kg posibles.",
          "hint": "Acceso a la obra compatible con grandes volúmenes y entregas en palé.",
          "selectLabel": "Sí — entregas en palé posibles"
        },
        "limited": {
          "label": "Acceso limitado",
          "description": "Edificio, piso, sin montacargas — solo pequeños envases.",
          "hint": "Acceso limitado: los grandes envases serán desactivados automáticamente.",
          "selectLabel": "No — acceso limitado, solo pequeños envases"
        },
        "fieldLabel": "Acceso gran volumen a la obra"
      }
    },
    "milestones": {
      "tabTitle": "Progreso",
      "empty": "Aún no hay hitos — se generan automáticamente a medida que avanzan las secciones y validaciones del proyecto.",
      "templates": {
        "project_started": "Proyecto iniciado",
        "preparation_completed": "Preparación completada",
        "surface_approval": "Aprobación de superficie",
        "surface_approval_desc": "Tu superficie está lista para la protección final. Valida el acabado antes de aplicar el sistema de protección.",
        "protection_completed": "Protección completada",
        "delivery": "Entrega",
        "custom": "Nuevo hito"
      },
      "status": {
        "Pending": "Pendiente",
        "AwaitingClient": "Aprobación del cliente requerida",
        "Approved": "Aprobado",
        "Completed": "Completado",
        "Rejected": "Modificación solicitada"
      },
      "approve": "Aprobar",
      "reject": "Solicitar modificación",
      "rejectComment": "Comentario (opcional)",
      "confirmReject": "Confirmar solicitud",
      "approvedByOn": "Aprobado por {{name}} el {{date}}",
      "approvalStale": "Esta sección se modificó después de que el cliente la aprobara — la validación podría ya no reflejar su estado actual.",
      "clientApproval": {
        "title": "Validación de superficie",
        "description": "Tu superficie está lista para la protección final. Valida el acabado antes de aplicar el sistema de protección."
      },
      "payment": {
        "NotDue": "No vencido",
        "Due": "Vencido",
        "Paid": "Pagado",
        "markPaid": "Marcar como pagado"
      }
    },
    "holded": {
      "createEstimate": "Crear presupuesto en Holded",
      "modalDescription": "Elige qué debe incluir el presupuesto \"{{name}}\".",
      "creating": "Creando...",
      "success": "Presupuesto creado en Holded (ID: {{id}})",
      "error": "Error al crear el presupuesto en Holded"
    },
    "header": {
      "totalCoatingSurfaceTooltip": "Superficie total a revestir",
      "totalCoatingSurface": "{{value}} m² a revestir"
    },
    "filters": {
      "allManagers": "Todos los jefes de proyecto",
      "allExecutionModes": "Todos los modos de ejecución",
      "lateOnly": "Solo retrasados",
      "sortBy": "Ordenar por",
      "sort": {
        "manual": "Orden manual",
        "name": "Nombre (A–Z)",
        "deadline": "Fecha límite, más próxima",
        "surface": "Superficie, mayor",
        "progress": "Progreso",
        "total": "Valor total"
      },
      "clearAll": "Borrar filtros"
    },
    "kpi": {
      "total": "Total de proyectos",
      "createdThisMonth_one": "+{{count}} este mes",
      "createdThisMonth_other": "+{{count}} este mes",
      "shareOfBook": "{{pct}} % de la cartera",
      "clickToIsolate": "Clic para aislar",
      "unassignedPm_one": "{{count}} sin jefe de proyecto",
      "unassignedPm_other": "{{count}} sin jefe de proyecto",
      "portfolioValue": "Valor de la cartera",
      "pricingLoading": "Calculando…",
      "incompleteCalc_one": "{{count}} cálculo incompleto",
      "incompleteCalc_other": "{{count}} cálculos incompletos",
      "upToDate": "Presupuesto completo",
      "avgProgress": "Progreso medio",
      "acrossActiveWork_one": "en {{count}} proyecto",
      "acrossActiveWork_other": "en {{count}} proyectos"
    },
    "list": {
      "surface": "Superficie",
      "progress": "Progreso",
      "total": "Total",
      "deadline": "Fecha límite",
      "lateBy_one": "retraso {{count}}d",
      "lateBy_other": "retraso {{count}}d",
      "unassigned": "Sin asignar"
    },
    "bulk": {
      "selectedCount_one": "{{count}} seleccionado",
      "selectedCount_other": "{{count}} seleccionados",
      "selectAll": "Seleccionar todo",
      "changeStatus": "Cambiar estado",
      "assignPm": "Asignar jefe de proyecto",
      "changeExecutionMode": "Cambiar modo de ejecución",
      "archive": "Archivar",
      "archiveTitle": "Archivar proyectos",
      "archiveConfirm_one": "¿Archivar {{count}} proyecto? El estado se puede volver a cambiar después.",
      "archiveConfirm_other": "¿Archivar {{count}} proyectos? El estado se puede volver a cambiar después.",
      "clearSelection": "Borrar selección",
      "statusApplied_one": "{{count}} proyecto actualizado",
      "statusApplied_other": "{{count}} proyectos actualizados",
      "pmApplied_one": "{{count}} proyecto actualizado",
      "pmApplied_other": "{{count}} proyectos actualizados",
      "executionModeApplied_one": "{{count}} proyecto actualizado",
      "executionModeApplied_other": "{{count}} proyectos actualizados",
      "partialFailure": "{{succeeded}} actualizados, {{failed}} fallidos"
    }
  },
  "contacts": {
    "title": "Contactos",
    "createButton": "Nuevo contacto",
    "createTitle": "Crear contacto",
    "editTitle": "Editar contacto",
    "searchPlaceholder": "Buscar por nombre, empresa, correo o teléfono...",
    "allTypes": "Todos los tipos",
    "noData": "No se encontraron contactos",
    "columns": {
      "name": "nombre",
      "type": "Tipo",
      "email": "correo",
      "phone": "teléfono",
      "entity": "Entidad"
    },
    "type": {
      "Individual": "Particular",
      "Company": "Empresa"
    },
    "status": {
      "active": "activo",
      "inactive": "Archivado"
    },
    "sections": {
      "general": "Información general",
      "contact": "Datos de contacto",
      "projects": "Associated proyectos",
      "enrollments": "Sesiones de cursos",
      "training": "Formación & Certificaciones"
    },
    "form": {
      "entity": "Entidad",
      "entityRequired": "La entidad es obligatoria",
      "type": "Tipo",
      "displayName": "Nombre para mostrar",
      "displayNameRequired": "El nombre para mostrar es obligatorio",
      "firstName": "Nombre",
      "lastName": "Apellidos",
      "companyName": "Nombre de la empresa",
      "email": "correo",
      "phone": "teléfono",
      "addressLine1": "dirección",
      "addressLine2": "Dirección (línea 2)",
      "postalCode": "Código postal",
      "city": "ciudad",
      "country": "País (ISO Alfa-2)",
      "notes": "notas"
    },
    "archive": {
      "title": "Archivar contacto",
      "confirm": "¿Seguro que deseas archivar «{{name}}»? Ya no será visible por defecto.",
      "action": "Archivar"
    },
    "projectColumns": {
      "name": "proyecto",
      "status": "estado"
    },
    "enrollmentColumns": {
      "course": "Curso",
      "date": "Fecha",
      "teacher": "Profesor",
      "status": "Estado"
    },
    "discount": {
      "sectionTitle": "Descuento y certificación",
      "permanentDiscount": "Descuento permanente",
      "baseDiscount": "Descuento base",
      "manualOverride": "Anulación manual del descuento",
      "manualOverrideHint": "Anulación del administrador (10%–35% en pasos de 2,5%). Se aplica si es mayor que el descuento basado en formación.",
      "linkedStudent": "ID de estudiante vinculado",
      "linkedStudentHint": "Vincula un registro de estudiante para habilitar descuentos basados en certificación",
      "linked": "Vinculado"
    },
    "installer": {
      "sectionTitle": "Instalador referenciado",
      "badge": "Instalador referenciado",
      "status": "Estado del instalador",
      "active": "activo",
      "inactive": "No publicado",
      "enable": "Publicar en el listado",
      "disable": "Quitar del listado",
      "requirement": "Certificación",
      "certificationLinked": "Estudiante vinculado",
      "certificationRequired": "Ningún estudiante vinculado — se requiere certificación"
    },
    "professional": {
      "sectionTitle": "Información profesional",
      "siren": "SIREN",
      "sirenRequired": "El SIREN es obligatorio",
      "sirenFormat": "El SIREN debe tener exactamente 9 dígitos",
      "sirenNotFound": "No se encontró ninguna empresa para este SIREN",
      "vatNumber": "Número de IVA",
      "vatRequired": "El número de IVA es obligatorio",
      "companyNameHint": "Nombre utilizado por tu contacto (puede diferir del nombre legal)",
      "companyNameRequired": "El nombre de la empresa es obligatorio",
      "legalName": "Razón social",
      "registeredAddress": "Domicilio social",
      "companyStatus": "Estado de la empresa",
      "statusRadiated": "Dada de baja",
      "director": "Director",
      "activity": "Actividad empresarial"
    },
    "hierarchy": {
      "link": "Vincular",
      "linkToCompany": "Vincular a empresa",
      "linkedContacts": "Contactos vinculados",
      "noLinkedContacts": "Ningún contacto individual vinculado.",
      "noParentCompany": "Ninguna empresa matriz vinculada.",
      "parentCompany": "Empresa matriz",
      "selectCompany": "Seleccionar empresa...",
      "selectIndividual": "Seleccionar contacto individual...",
      "unlink": "Desvincular",
      "unlinkConfirm": "¿Desvincular \"{{name}}\" de esta empresa?",
      "unlinkParentConfirm": "¿Eliminar el vínculo con \"{{name}}\"?",
      "unlinkTitle": "Desvincular contacto"
    }
  },
  "colors": {
    "title": "Selector de color",
    "colorCount": "colores",
    "importButton": "Importar matriz CSV",
    "exportButton": "Exportar matriz CSV",
    "importSuccess": "Importación exitosa",
    "importSuccessCount": "{{count}} colores importados.",
    "noData": "No hay fórmulas de color cargadas. Importa una matriz CSV para empezar.",
    "noCollection": "Otro",
    "weight": "Peso (kg)",
    "weightHint": "Las cantidades de pigmento escalan con el peso",
    "coating": "Base del coating",
    "pigments": "Pigmentos",
    "productNotFound": "Producto no encontrado en el catálogo",
    "needed": "necesario:",
    "unit": "unidad",
    "subtotal": "Subtotal:",
    "grandTotal": "total",
    "pickColor": "Elegir un color",
    "searchPlaceholder": "Buscar colores...",
    "noResults": "Ningún color coincide con tu búsqueda",
    "removeColor": "Quitar color"
  },
  "courses": {
    "enroll": {
      "search": "Buscar contactos",
      "searchPlaceholder": "Buscar por nombre o correo...",
      "contact": "Contacto",
      "contactPlaceholder": "Selecciona un contacto...",
      "noResults": "No se encontraron contactos",
      "action": "Inscribir"
    }
  },
  "teachers": {
    "title": "Profesores certificados",
    "createButton": "Nuevo profesor",
    "createTitle": "Añadir profesor",
    "editTitle": "Editar profesor",
    "backToList": "Volver a profesores",
    "searchPlaceholder": "Buscar por nombre, correo o país...",
    "allStatuses": "Todos los estados",
    "noData": "No se encontraron profesores",
    "inactive": "inactivo",
    "noCertifiedLevels": "Sin niveles certificados",
    "columns": {
      "name": "nombre",
      "certification": "Certificación",
      "levels": "Niveles certificados",
      "languages": "Idiomas",
      "validity": "Válido hasta"
    },
    "certificationStatus": {
      "Pending": "Pendiente",
      "Active": "activo",
      "Expired": "Caducada",
      "Revoked": "Revocada"
    },
    "form": {
      "fullName": "Nombre completo",
      "fullNameRequired": "El nombre completo es obligatorio",
      "email": "correo",
      "emailRequired": "El correo es obligatorio",
      "country": "País (ISO Alfa-2)",
      "languages": "Idiomas",
      "certifiedLevels": "Niveles certificados",
      "specialties": "Especialidades",
      "specialtiesPlaceholder": "Piscina, Exterior...",
      "isActive": "Profesor activo"
    },
    "certify": {
      "title": "Certificar profesor",
      "action": "Certificar",
      "levels": "Niveles a certificar",
      "levelsRequired": "Selecciona al menos un nivel",
      "certificationDate": "Fecha de certificación",
      "expirationDate": "Fecha de caducidad",
      "expirationRequired": "La fecha de caducidad es obligatoria",
      "selfCertifyNote": "Un profesor no puede autocertificarse. Esta acción está reservada a los administradores de Mas Maya.",
      "expired": "Certificación caducada"
    },
    "revoke": {
      "title": "Revocar certificación",
      "confirm": "¿Seguro que deseas revocar la certificación de este profesor? Ya no podrá impartir sesiones.",
      "action": "Revocar"
    },
    "info": {
      "certification": "Certificación",
      "profile": "perfil",
      "certifiedOn": "Certificado el",
      "expiresOn": "Caduca el"
    },
    "sessions": {
      "title": "Sesiones asignadas",
      "empty": "Ninguna sesión asignada"
    },
    "evaluations": {
      "title": "Evaluaciones de estudiantes",
      "student": "estudiante",
      "score": "Puntuación",
      "notes": "notas",
      "date": "fecha"
    },
    "evaluate": {
      "title": "Evaluar estudiante",
      "addButton": "Añadir evaluación",
      "action": "Enviar",
      "student": "estudiante",
      "studentPlaceholder": "Seleccionar un estudiante...",
      "noStudents": "No se encontraron estudiantes",
      "score": "Puntuación (1–5)",
      "scoreHint": "1 = necesita mejorar, 5 = excelente",
      "notes": "notas"
    }
  },
  "students": {
    "title": "Estudiantes",
    "createButton": "Nuevo estudiante",
    "createTitle": "Añadir estudiante",
    "searchPlaceholder": "Buscar por nombre o correo...",
    "noData": "No se encontraron estudiantes",
    "type": {
      "Individual": "Particular",
      "Professional": "Profesional"
    },
    "columns": {
      "name": "nombre",
      "email": "correo",
      "type": "Tipo",
      "company": "Empresa",
      "country": "país",
      "language": "Idioma"
    },
    "form": {
      "firstName": "Nombre",
      "firstNameRequired": "El nombre es obligatorio",
      "lastName": "Apellidos",
      "lastNameRequired": "Los apellidos son obligatorios",
      "email": "correo",
      "emailRequired": "El correo es obligatorio",
      "phone": "teléfono",
      "type": "Tipo",
      "companyName": "Nombre de la empresa"
    }
  },
  "certifications": {
    "title": "Certificaciones de aplicador",
    "allLevels": "Todos los niveles",
    "allStatuses": "Todos los estados",
    "searchPlaceholder": "Buscar por nombre o correo...",
    "noData": "No se encontraron certificaciones",
    "viewLevels": "Ver definiciones de nivel",
    "publicPage": "Página pública",
    "status": {
      "Pending": "Pendiente",
      "Passed": "Aprobada",
      "Failed": "Suspendida",
      "Expired": "Caducada"
    },
    "columns": {
      "student": "Estudiante",
      "level": "Nivel",
      "status": "estado",
      "issuedAt": "Emitida el",
      "expiration": "Vence el",
      "session": "Sesión",
      "finishes": "Acabados expertos",
      "certifications": "Certificaciones"
    },
    "issue": {
      "title": "Emitir certificación",
      "action": "Emitir",
      "levelRequired": "El nivel es obligatorio",
      "level": "Nivel de certificación",
      "issuedAt": "Fecha de emisión",
      "expirationDate": "Fecha de caducidad",
      "notes": "notas",
      "basicNote": "Las certificaciones básicas se validan automáticamente tras la participación completa y no pueden suspenderse.",
      "allLevelsIssued": "Este estudiante ya tiene certificaciones para todos los niveles.",
      "alreadyIssued": "Certificación ya emitida para este nivel",
      "absentCannotIssue": "No se puede emitir una certificación a un estudiante ausente",
      "expertFinishes": "Acabados expertos validados",
      "terrazzoMetadata": "Terrazzo — base + 3 colores de incrustación",
      "terrazzoPlaceholder": "p.ej. Base blanca, negro, dorado, óxido"
    },
    "update": {
      "title": "Actualizar certificación",
      "action": "Guardar",
      "status": "estado",
      "addFinish": "Validar acabado experto",
      "selectFinish": "Seleccionar un acabado...",
      "validateFinish": "Validar acabado"
    },
    "levels": {
      "title": "Niveles de certificación de aplicador",
      "subtitle": "Requisitos y alcance de cada nivel de certificación",
      "skills": "Alcance de aplicación",
      "products": "Productos requeridos",
      "finishes": "Acabados creativos",
      "canFail": "Puede suspenderse",
      "cannotFail": "No puede suspenderse",
      "autoValidates": "Se valida automáticamente"
    },
    "levelDefinitions": {
      "basic": {
        "title": "Aplicador Básico",
        "skills": {
          "interiorWalls": "Paredes interiores",
          "interiorFloors": "Suelos interiores",
          "interiorCeilings": "Techos interiores",
          "cleanStableSubstrates": "Sustratos limpios y estables"
        }
      },
      "intermediate": {
        "title": "Aplicador Intermedio",
        "skills": {
          "protectedExteriors": "Exteriores protegidos",
          "complexInteriors": "Interiores complejos",
          "deterioratedSubstrates": "Sustratos deteriorados",
          "correctivePrep": "Preparación correctiva"
        }
      },
      "expert": {
        "title": "Aplicador Experto",
        "skills": {
          "wetRooms": "Estancias húmedas",
          "showers": "Duchas",
          "bathtubs": "Bañeras",
          "pools": "Piscinas",
          "fountains": "Fuentes",
          "facades": "Fachadas",
          "wetAreas": "Zonas húmedas"
        }
      },
      "expertFinishes": {
        "title": "Aplicador Experto en Acabados",
        "skills": {
          "advancedCreativeFinishes": "Acabados avanzados y creativos"
        },
        "finishes": {
          "pise": "Pisé (tierra apisonada)",
          "castConcreteAcetate": "Hormigón colado (acetato)",
          "woodFormworkConcrete": "Hormigón con encofrado de madera",
          "burntEffect": "Efecto quemado",
          "brushedConcrete": "Hormigón cepillado",
          "rawSandEffect": "Efecto arena bruta",
          "shouSugiBan": "Shou Sugi Ban",
          "naturalStoneEffect": "Efecto piedra natural",
          "terrazzoEffect": "Efecto terrazo (base + 3 incrustaciones)"
        }
      },
      "products": {
        "preparation": "Preparación",
        "base": "Base"
      }
    },
    "public": {
      "subtitle": "{{count}} certificación(es) validada(s)",
      "noData": "No se encontraron certificaciones para este aplicador.",
      "footer": "Certificado por Mas Maya · masmaya.fr"
    },
    "admin": {
      "newDefinition": "Nueva definición",
      "editDefinition": "Editar definición",
      "noDefinitions": "Sin definiciones.",
      "form": {
        "name": "Nombre",
        "slug": "Slug",
        "slugDescription": "Identificador URL único (p.ej. basic-applicator)",
        "category": "Categoría",
        "prerequisites": "Prerrequisitos",
        "description": "Descripción",
        "sortOrder": "Orden de visualización",
        "isActive": "Activo"
      },
      "columns": {
        "name": "Nombre",
        "slug": "Slug",
        "category": "Categoría",
        "prerequisites": "Prerrequisitos",
        "order": "Orden",
        "active": "Activo"
      }
    }
  },
  "finishEvaluation": {
    "modalTitle": "Evaluación de acabado experto",
    "evaluateAction": "Evaluar acabado",
    "finishType": "Tipo de acabado",
    "finishPlaceholder": "Seleccionar un acabado...",
    "finishRequired": "Selecciona un tipo de acabado",
    "score": "Puntuación (0–10)",
    "willFail": "Por debajo del umbral de aprobado",
    "photos": "Fotos",
    "photosBefore": "Fotos previas",
    "photosDuring": "Fotos durante el proceso",
    "photosAfter": "Fotos posteriores",
    "dropPhotos": "Suelta imágenes o haz clic para explorar",
    "photosRequired": "Se requiere al menos una foto previa y una posterior",
    "terrazzoColors": "Colores del terrazzo",
    "terrazzoBase": "Color base",
    "terrazzoColor1": "Incrustación 1",
    "terrazzoColor2": "Incrustación 2",
    "terrazzoColor3": "Incrustación 3",
    "terrazzoColorsRequired": "Se requieren los cuatro colores del terrazzo",
    "submit": "Enviar evaluación",
    "uploading": "Subiendo fotos…",
    "historyTitle": "Evaluaciones de acabado experto",
    "attempts": "{{count}} intento(s)",
    "finishes": {
      "Pise": {
        "label": "Efecto pisé",
        "description": "Compactación capa a capa que imita el pisé tradicional."
      },
      "BetonCoule": {
        "label": "Hormigón vertido con acetato",
        "description": "Hormigón vertido con lámina de acetato para un acabado liso y brillante."
      },
      "BetonCoffrage": {
        "label": "Hormigón encofrado en madera",
        "description": "Impronta de tablas de madera en el hormigón para una textura estructurada."
      },
      "EffetBrule": {
        "label": "Efecto quemado",
        "description": "Piedra muy firme o llana de acero inoxidable para crear una textura quemada."
      },
      "BetonBrosse": {
        "label": "Hormigón cepillado",
        "description": "Cepillado de hormigón fresco para crear una superficie texturizada con estrías."
      },
      "EffetBrut": {
        "label": "Efecto bruto con restos de arena",
        "description": "Acabado en bruto que deja restos visibles de arena en la superficie."
      },
      "ShouSugiBan": {
        "label": "Madera quemada Shou Sugi Ban",
        "description": "Técnica japonesa de quemado de madera aplicada durante el desmoldeo."
      },
      "EffetPierre": {
        "label": "Efecto piedra natural",
        "description": "Imitación de la textura y apariencia de la piedra natural."
      },
      "EffetTerrazzo": {
        "label": "Efecto terrazzo",
        "description": "Terrazzo con color base y 3 incrustaciones de color."
      }
    }
  },
  "certificates": {
    "title": "Certificados digitales",
    "status": {
      "Active": "activo",
      "Expired": "Caducado",
      "Revoked": "Revocado"
    },
    "verify": {
      "title": "Verificación de certificado",
      "code": "Código de verificación",
      "level": "Nivel de certificación",
      "specialties": "Especialidades",
      "issued": "Emitido",
      "expires": "Caduca",
      "revokedOn": "Revocado el",
      "validNote": "Este certificado ha sido emitido por Mas Maya y es verificable criptográficamente.",
      "notFound": "Certificado no encontrado",
      "notFoundDesc": "No existe ningún certificado con este código de verificación.",
      "link": "Verificar"
    },
    "revoke": {
      "title": "Revocar certificado",
      "confirm": "¿Seguro que deseas revocar este certificado? Esta acción no se puede deshacer.",
      "action": "Revocar",
      "defaultReason": "Revocado por el administrador"
    }
  },
  "evaluation": {
    "modalTitle": "Evaluación de certificación",
    "evaluateCertification": "Evaluar certificación",
    "selectStudent": "Estudiante",
    "studentPlaceholder": "Seleccionar un estudiante...",
    "studentRequired": "Selecciona un estudiante",
    "criteria": "Criterios de evaluación",
    "scoreRange": "Puntuación 0–10",
    "finalScore": "Puntuación global",
    "willPass": "Aprobará",
    "willFail": "{{count}} criterio(s) suspendido(s)",
    "failAlert": "Los siguientes criterios están por debajo del umbral: {{criteria}}",
    "teacherNotes": "Notas del profesor",
    "notesPlaceholder": "Observaciones, puntos de mejora...",
    "noCriteria": "No hay criterios definidos para este nivel",
    "submit": "Enviar evaluación",
    "history": "Historial de evaluaciones",
    "passed": "Aprobado",
    "failed": "Suspendido",
    "failedCriteria": "Criterios suspendidos",
    "retrySessions": "Sesiones de repesca disponibles",
    "seats": "plazas"
  },
  "dashboard": {
    "title": "Panel de control",
    "subtitle": "Resumen de tu actividad de formación",
    "upcomingSessions": "Próximas sesiones",
    "stats": {
      "students": "estudiantes",
      "teachers": "profesores",
      "activeCerts": "Certificaciones activas",
      "pendingCerts": "Pendientes",
      "upcomingSessions": "Próximas (30 días)",
      "passedThisYear": "Aprobadas este año"
    },
    "projectsOverview": {
      "title": "Proyectos",
      "active": "Activos",
      "blocked": "Bloqueados",
      "awaitingValidation": "Esperando validación",
      "late": "Con retraso",
      "needsAttention": "Requiere tu atención"
    }
  },
  "teacherDashboard": {
    "welcomeLabel": "Bienvenido de nuevo",
    "noProfile": "Ningún perfil de profesor",
    "noProfileDesc": "Ningún perfil de profesor está vinculado a tu cuenta.",
    "upcomingSessions": "Tus próximas sesiones",
    "recentEvaluations": "Evaluaciones recientes",
    "noSessions": "Ninguna sesión asignada",
    "stats": {
      "upcoming": "Próximas",
      "sessions": "Total de sesiones",
      "evaluations": "Evaluaciones"
    }
  },
  "studentPortal": {
    "title": "Portal del estudiante",
    "subtitle": "Accede a tus resultados de formación, certificaciones y próximas sesiones.",
    "emailLabel": "Tu dirección de correo",
    "emailPlaceholder": "estudiante@ejemplo.com",
    "lookup": "Acceder a mi perfil",
    "notFound": "No se encontró ninguna cuenta",
    "profileLabel": "Mi perfil",
    "profileNotFound": "Perfil no encontrado",
    "upcomingSessions": "Próximas sesiones",
    "pastSessions": "Sesiones pasadas",
    "footer": "Mas Maya Formación · masmaya.fr",
    "privacyNote": "Solo se muestran tus datos de formación. No se requiere cuenta ni contraseña."
  },
  "enroll": {
    "title": "Inscríbete en una sesión",
    "firstName": "Nombre",
    "lastName": "Apellidos",
    "email": "Correo electrónico",
    "type": "Tipo",
    "company": "Empresa / Organización",
    "country": "País (código de 2 letras)",
    "language": "Idioma preferido",
    "seatsLeft": "{{count}} plaza(s) disponible(s)",
    "submit": "Inscribirse",
    "requiredFields": "Rellena todos los campos obligatorios.",
    "notOpen": "Inscripción no abierta",
    "notOpenDesc": "Esta sesión no está actualmente abierta para inscripción.",
    "sessionNotFound": "Sesión no encontrada",
    "successTitle": "¡Inscripción confirmada!",
    "successDesc": "Tu plaza está reservada. Recibirás una confirmación por correo electrónico.",
    "viewProfile": "Ver mi perfil",
    "error": "Se produjo un error. Inténtalo de nuevo.",
    "privacyNote": "Tus datos se utilizan únicamente con fines formativos.",
    "professional": {
      "siren": "Número SIREN",
      "sirenDesc": "9 dígitos — búsqueda automática vía Pappers",
      "sirenRequired": "El número SIREN es obligatorio (9 dígitos).",
      "sirenNotFound": "Empresa no encontrada o SIREN inválido.",
      "vatNumber": "Número de IVA",
      "vatRequired": "El número de IVA es obligatorio.",
      "companyRequired": "El nombre de la empresa es obligatorio.",
      "companyNameDesc": "Nombre utilizado comercialmente (puede diferir del nombre legal)",
      "director": "Director",
      "radiated": "Empresa disuelta / cerrada"
    }
  },
  "cart": {
    "title": "Carrito",
    "empty": "El carrito está vacío",
    "clear": "Vaciar carrito",
    "clearTitle": "Vaciar carrito",
    "clearConfirm": "¿Eliminar todos los artículos de este carrito?",
    "clearAction": "Vaciar",
    "training": "Formación",
    "subtotal": "Subtotal",
    "discount": "Descuento",
    "total": "total",
    "columns": {
      "item": "Artículo",
      "unitPrice": "Precio unitario",
      "qty": "Cant.",
      "total": "total"
    },
    "discountReason": {
      "base": "Tarifa base",
      "manual_override": "Descuento manual del administrador",
      "cart_training_incentive": "Desbloqueado al añadir formación",
      "certification_Basic": "Certificación básica",
      "certification_Intermediate": "Certificación intermedia",
      "certification_Expert": "Certificación experta",
      "certification_ExpertFinishes": "Certificación de acabados expertos"
    },
    "upsell": {
      "title": "Desbloquea un descuento",
      "addTraining": "Añadir {{title}} al carrito",
      "level": {
        "Basic": "Básico",
        "Intermediate": "Intermedio",
        "Expert": "Experto",
        "ExpertFinishes": "Acabados expertos"
      }
    }
  },
  "entities": {
    "title": "Entidades",
    "createButton": "Nueva entidad",
    "createTitle": "Crear entidad",
    "editTitle": "Editar entidad",
    "searchPlaceholder": "Buscar por nombre, código o país...",
    "showArchived": "Mostrar archivados",
    "noData": "No se encontraron entidades",
    "noUsers": "Ningún usuario asignado",
    "viewUsers": "Ver usuarios",
    "columns": {
      "name": "nombre",
      "code": "Código",
      "country": "País",
      "status": "estado",
      "users": "Usuarios"
    },
    "status": {
      "active": "activo",
      "inactive": "inactivo"
    },
    "sections": {
      "general": "Información general",
      "users": "Usuarios asignados",
      "staff": "Miembros del personal"
    },
    "noStaff": "Ningún miembro del personal para esta entidad",
    "form": {
      "name": "nombre",
      "nameRequired": "El nombre es obligatorio",
      "code": "Código interno",
      "codePlaceholder": "e.g. CORP-FR",
      "country": "País (ISO Alfa-2)",
      "countryPlaceholder": "Seleccionar un país",
      "countryRequired": "El país es obligatorio",
      "currency": "Moneda (ISO 4217)",
      "timezone": "Zona horaria",
      "email": "Correo de contacto",
      "logoUrl": "URL del logotipo",
      "isActive": "activo"
    },
    "archive": {
      "title": "Archivar entidad",
      "confirm": "¿Seguro que deseas archivar «{{name}}»? Ya no será visible por defecto.",
      "confirm_action": "Archivar"
    },
    "assignUser": {
      "title": "Asignar un usuario",
      "button": "Asignar usuario",
      "searchLabel": "Buscar usuario",
      "searchPlaceholder": "Nombre o correo...",
      "noResults": "No se encontraron usuarios",
      "selected": "Seleccionado",
      "assign": "Asignar"
    },
    "removeUser": {
      "title": "Quitar usuario",
      "confirm": "¿Quitar a {{name}} de esta entidad?"
    },
    "managers": {
      "title": "Responsables",
      "role": "Responsable de entidad",
      "noAvailable": "Ningún usuario disponible"
    },
    "userColumns": {
      "name": "nombre",
      "email": "correo",
      "assignedOn": "Asignado el"
    },
    "quoteConfig": {
      "title": "Configuración del presupuesto",
      "subtitle": "Valores predeterminados utilizados para el cálculo de consumo",
      "consumptionRates": "Tasas de consumo",
      "wasteFactors": "Factores de merma",
      "labourRates": "Tarifas de mano de obra",
      "complexityMultipliers": "Multiplicadores de complejidad",
      "fields": {
        "coating1LayerKgPerM2": "Coating 1 capa",
        "coating2LayerKgPerM2": "Coating 2 capas",
        "mixingWaterWallLPerKg": "Agua de mezcla (pared)",
        "mixingWaterFloorLPerKg": "Agua de mezcla (suelo)",
        "prepCoverageM2Per10Kg": "Prep",
        "primerCoverageM2PerL": "Primer",
        "poolPrimerCoverageM2PerL": "Pool Primer",
        "presealerCoverageM2PerL": "Presealer",
        "sealerCoverageM2PerL": "Sealer",
        "heavyDutySealerCoverageM2PerL": "Heavy-Duty Sealer",
        "meshWasteFactor": "Merma de malla (simple)",
        "meshComplexWasteFactor": "Merma de malla (compleja)",
        "generalWasteFactor": "Merma general",
        "labourRatePerM2": "Tarifa / m²",
        "labourRatePerSurface": "Tarifa / superficie",
        "labourRatePerProduct": "Tarifa / producto",
        "complexityLow": "Baja",
        "complexityNormal": "Normal",
        "complexityMedium": "Media",
        "complexityHigh": "Alta",
        "repairMinSurfaceM2": "Superficie mín. de reparación (m²)",
        "prepMarginPercent": "Margen Prep",
        "primerMarginPercent": "Margen Primer",
        "poolPrimerMarginPercent": "Margen Pool Primer",
        "coatingMarginPercent": "Margen Coating",
        "meshMarginPercent": "Margen Mesh",
        "presealerMarginPercent": "Margen Presealer",
        "sealerMarginPercent": "Margen Sealer",
        "heavyDutySealerMarginPercent": "Margen HD Sealer",
        "pigmentMarginPercent": "Margen Pigmentos"
      },
      "siteLogistics": "Logística de obra",
      "maxSmallAccessCoatingBag": "Tamaño máximo de saco de coating sin acceso gran volumen",
      "materialMargin": "Márgenes de materiales",
      "markups": {
        "title": "Recargos de obra",
        "occupiedSite": "Obra ocupada (%)",
        "furnishedRoom": "Habitación amueblada (%)",
        "standardFinishDiscount": "Descuento acabado estándar (%)",
        "standardFinishDiscountHint": "Las tarifas base de mano de obra están calibradas para el acabado Premium. Este descuento se aplica cuando el acabado de una sección es Estándar."
      },
      "degressiveRates": "Tarifas de mano de obra degresivas por m²",
      "addTier": "Añadir tramo",
      "tierFields": {
        "minSurface": "Superficie mín.",
        "maxSurface": "Superficie máx.",
        "rate": "Tarifa (€/m²)",
        "enabled": "Activo"
      },
      "taskGenConfig": {
        "title": "Variables de generación de tareas",
        "save": "Guardar variables",
        "saveSuccess": "Variables de generación guardadas.",
        "saveError": "Error al guardar.",
        "unsavedWarning": "Cambios sin guardar. Haz clic en Guardar para aplicarlos a futuras generaciones.",
        "critical": "Crítico",
        "taskFamilies": {
          "title": "Activar familias de tareas",
          "description": "Desactivar una familia impide que estas tareas se generen en nuevos proyectos. Las tareas existentes no se eliminan.",
          "preparation": "Preparación del soporte",
          "primer": "Imprimación",
          "mesh": "Malla / rejilla",
          "coating": "Capas de acabado",
          "drying": "Tiempo de secado",
          "presealer": "Presealer",
          "sealer": "Sealer",
          "heavyDuty": "Heavy-Duty Sealer",
          "qualityControl": "Control de calidad",
          "aftercare": "Aftercare / protección",
          "handover": "Entrega al cliente (Handover)"
        },
        "substratePrep": {
          "title": "Preparación del soporte",
          "inspection": "Inspección del sustrato",
          "surfaceCleaning": "Limpieza de superficie",
          "sanding": "Lijado",
          "dustRemoval": "Eliminación de polvo",
          "maskingProtection": "Protección de zonas adyacentes",
          "crackTreatment": "Tratamiento de grietas",
          "jointTreatment": "Tratamiento de juntas",
          "maxImperfectionMm": "Imperfección máx.",
          "maxImperfectionHint": "Umbral por encima del cual se genera una tarea de relleno"
        },
        "primer": {
          "title": "Imprimación",
          "minWaitMinutes": "Espera mín. — imprimación estándar",
          "minWaitHint": "Tiempo mínimo antes de aplicar la primera capa",
          "maxWindowHours": "Ventana máx. — imprimación estándar",
          "maxWindowHint": "La capa debe aplicarse antes de este tiempo",
          "poolMinWaitMinutes": "Espera mín. — imprimación piscina",
          "poolMinWaitHint": "Pool Primer — espera mínima antes del coating"
        },
        "mixing": {
          "title": "Mezcla y capas",
          "mixRestMinutes": "Reposo de mezcla",
          "mixRestHint": "Tiempo de reposo tras mezclar antes de aplicar",
          "wallWaterRatio": "Ratio agua pared",
          "floorWaterRatio": "Ratio agua suelo",
          "baseLayerThickness": "Grosor capa base",
          "finishLayerThickness": "Grosor capa de acabado"
        },
        "mesh": {
          "title": "Malla / Rejilla",
          "overlapCm": "Solape de malla",
          "edgeDistanceCm": "Distancia borde malla",
          "requiredFor": "Malla obligatoria para",
          "floors": "Suelos",
          "stairs": "Escaleras",
          "tiles": "Azulejos",
          "wood": "Madera",
          "pools": "Piscinas",
          "bathrooms": "Baños",
          "exteriors": "Fachadas / exterior"
        },
        "waterproofing": {
          "title": "Impermeabilización",
          "description": "El revestimiento Mas Maya es resistente al agua pero no impermeabilizante. Se requiere membrana en los siguientes casos.",
          "wetZones": "Membrana requerida — zonas húmedas",
          "wetZonesHint": "Zonas húmedas, exposición directa al agua",
          "pools": "Membrana requerida — piscinas",
          "bathrooms": "Membrana requerida — baños"
        },
        "presealer": {
          "title": "Presealer",
          "numberOfCoats": "Número de capas",
          "waitBetweenCoats": "Espera entre capas"
        },
        "sealer": {
          "title": "Sealer estándar",
          "ratioA": "Ratio A",
          "ratioAHint": "Parte A de la mezcla (ej: 5)",
          "ratioB": "Ratio B",
          "ratioBHint": "Parte B de la mezcla (ej: 1)",
          "mixRestMinutes": "Reposo de mezcla",
          "numberOfCoats": "Número de capas",
          "waitBetweenCoats": "Espera entre capas",
          "fullCureHours": "Curado completo"
        },
        "heavyDuty": {
          "title": "Heavy-Duty Sealer",
          "ratioA": "Ratio A",
          "ratioB": "Ratio B",
          "waitBetweenCoats": "Espera entre capas",
          "fullCureHours": "Curado completo",
          "minTempC": "Temp. mín. aplicación",
          "maxTempC": "Temp. máx. aplicación",
          "requiredFor": "Heavy-Duty obligatorio para",
          "floors": "Suelos",
          "stairs": "Escaleras",
          "exteriors": "Exterior",
          "pools": "Piscinas",
          "highTraffic": "Zonas de alto tráfico"
        },
        "pool": {
          "title": "Reglas de piscina",
          "fillWaitDays": "Espera antes de llenar",
          "fillWaitHint": "Duración mínima antes de llenar la piscina",
          "waterlineMarginCm": "Margen HD línea de agua",
          "waterlineMarginHint": "Ancho de la zona Heavy-Duty alrededor de la línea de flotación"
        },
        "exterior": {
          "title": "Reglas exterior",
          "minTempC": "Temperatura mín.",
          "maxTempC": "Temperatura máx."
        },
        "aftercare": {
          "title": "Aftercare y restricciones de uso",
          "noWaterDays": "Protección absoluta",
          "noWaterHint": "Sin contacto ni humedad",
          "noTrafficDays": "Sin tráfico",
          "lightUseStartDay": "Uso ligero desde el día",
          "normalUseAfterDays": "Uso normal después de",
          "resealYearsMin": "Re-sealing recomendado en",
          "resealYearsMax": "Re-sealing recomendado antes de"
        },
        "layerExceptions": {
          "title": "Excepciones sistema mono/bi-capa",
          "description": "El sistema estándar Mas Maya es 2 mm capa base + malla + 2 mm acabado. Estas excepciones solo deben activarse para superficies interiores secas ideales.",
          "allowOneLayer": "Permitir sistema mono-capa sin malla",
          "allowOneLayerHint": "Solo paredes interiores perfectas y secas",
          "oneLayerWalls": "Mono-capa permitida en paredes",
          "oneLayerCeilings": "Mono-capa permitida en techos",
          "allowTwoLayer": "Permitir bi-capa sin malla",
          "allowTwoLayerHint": "Solo paredes texturadas estables",
          "twoLayerStableWalls": "Bi-capa sin malla en paredes texturadas estables"
        },
        "underfloorHeating": {
          "title": "Calefacción por suelo radiante",
          "warning": "Modificar los parámetros de reinicio puede afectar al rendimiento del revestimiento. Modifica estos valores solo siguiendo la documentación técnica de Mas Maya.",
          "generationTitle": "Generación",
          "generateTasks": "Generar tareas de suelo radiante",
          "requireQuestion": "Preguntar por calefacción en secciones de suelo",
          "generateShutdown": "Tarea de apagado de calefacción",
          "generateRestart": "Tareas de reinicio de calefacción",
          "generateProgressiveHeatUp": "Calentamiento progresivo (tareas por día)",
          "generateMonitoring": "Tareas de control de temperatura",
          "generateClientHandover": "Entrega de instrucciones al cliente",
          "shutdownTitle": "Apagado antes de la aplicación",
          "shutdownBeforeApplication": "Horas de apagado antes de la aplicación",
          "shutdownBeforeSealer": "Horas de apagado antes del sellante",
          "offDuringApplication": "Calefacción apagada durante la aplicación",
          "offDuringCure": "Calefacción apagada durante el curado",
          "restartTitle": "Reinicio progresivo",
          "restartAfterSealer": "Espera tras sellante final antes de reiniciar",
          "restartStartTemp": "Temperatura de inicio",
          "restartTempIncrement": "Incremento por día",
          "restartMaxTemp": "Temperatura máxima",
          "restartMinDuration": "Duración mínima de subida",
          "restartRequiresValidation": "Validación requerida al completar",
          "controlsTitle": "Controles",
          "dailyTempCheck": "Control diario de temperatura",
          "floorSurfaceTempCheck": "Control de superficie del suelo antes de reiniciar",
          "clientWarningRapidHeatUp": "Advertencia al cliente sobre calentamiento rápido",
          "restartCompletionQc": "QC final tras reinicio"
        }
      }
    },
    "taskGenConfig": {
      "title": "Variables de generación de tareas",
      "save": "Guardar variables",
      "saveError": "Error al guardar.",
      "saveSuccess": "Variables de generación guardadas.",
      "critical": "Crítico",
      "unsavedWarning": "Cambios no guardados. Haga clic en Guardar para aplicarlos a futuras generaciones.",
      "aftercare": {
        "title": "Aftercare y restricciones de uso",
        "lightUseStartDay": "Uso ligero a partir del día",
        "noTrafficDays": "Sin tráfico",
        "noWaterDays": "Protección absoluta",
        "noWaterHint": "Sin contacto ni humedad",
        "normalUseAfterDays": "Uso normal después de",
        "resealYearsMax": "Nuevo sellado recomendado antes de",
        "resealYearsMin": "Nuevo sellado recomendado en"
      },
      "exterior": {
        "title": "Reglas exterior",
        "maxTempC": "Temperatura máx.",
        "minTempC": "Temperatura mín."
      },
      "heavyDuty": {
        "title": "Heavy-Duty Sealer",
        "exteriors": "Exteriores",
        "floors": "Suelos",
        "fullCureHours": "Curado completo",
        "highTraffic": "Zona de alto tráfico",
        "maxTempC": "Temperatura máx. de aplicación",
        "minTempC": "Temperatura mín. de aplicación",
        "pools": "Piscinas",
        "ratioA": "Proporción A",
        "ratioB": "Proporción B",
        "requiredFor": "Heavy-Duty obligatorio para",
        "stairs": "Escaleras",
        "waitBetweenCoats": "Espera entre capas"
      },
      "layerExceptions": {
        "title": "Excepciones mono/bicapa",
        "description": "El sistema estándar Mas Maya es 2 mm capa base + malla + 2 mm acabado. Estas excepciones solo deben activarse para superficies ideales en interior seco.",
        "allowOneLayer": "Permitir sistema monocapa sin malla",
        "allowOneLayerHint": "Solo para paredes interiores perfectas y secas",
        "allowTwoLayer": "Permitir bicapa sin malla",
        "allowTwoLayerHint": "Solo para paredes texturizadas estables",
        "oneLayerCeilings": "Monocapa permitido en techos",
        "oneLayerWalls": "Monocapa permitido en paredes",
        "twoLayerStableWalls": "Bicapa sin malla en paredes texturizadas estables"
      },
      "mesh": {
        "title": "Malla / Tejido",
        "bathrooms": "Baños",
        "edgeDistanceCm": "Distancia borde malla",
        "exteriors": "Fachadas / exterior",
        "floors": "Suelos",
        "overlapCm": "Solapamiento malla",
        "pools": "Piscinas",
        "requiredFor": "Malla obligatoria para",
        "stairs": "Escaleras",
        "tiles": "Azulejos",
        "wood": "Madera"
      },
      "mixing": {
        "title": "Mezcla y capas",
        "baseLayerThickness": "Grosor capa base",
        "finishLayerThickness": "Grosor capa de acabado",
        "floorWaterRatio": "Proporción agua suelo",
        "mixRestHint": "Tiempo de reposo después de mezclar antes de aplicar",
        "mixRestMinutes": "Reposo de la mezcla",
        "wallWaterRatio": "Proporción agua pared"
      },
      "pool": {
        "title": "Reglas piscina",
        "fillWaitDays": "Espera antes de llenado",
        "fillWaitHint": "Duración mínima antes de llenar la piscina",
        "waterlineMarginCm": "Margen línea de agua HD",
        "waterlineMarginHint": "Ancho de zona Heavy-Duty alrededor de la línea de flotación"
      },
      "presealer": {
        "title": "Presealer",
        "numberOfCoats": "Número de capas",
        "waitBetweenCoats": "Espera entre capas"
      },
      "primer": {
        "title": "Imprimación",
        "maxWindowHint": "La capa debe aplicarse antes de este tiempo",
        "maxWindowHours": "Ventana máx. imprimación estándar",
        "minWaitHint": "Espera mínima antes de aplicar la primera capa",
        "minWaitMinutes": "Espera mín. imprimación estándar",
        "poolMinWaitHint": "Imprimación de piscina — espera mínima antes de coating",
        "poolMinWaitMinutes": "Espera mín. imprimación piscina"
      },
      "sealer": {
        "title": "Sellador estándar",
        "fullCureHours": "Curado completo",
        "mixRestMinutes": "Reposo de la mezcla",
        "numberOfCoats": "Número de capas",
        "ratioA": "Proporción A",
        "ratioAHint": "Parte A de la mezcla (ej: 5)",
        "ratioB": "Proporción B",
        "ratioBHint": "Parte B de la mezcla (ej: 1)",
        "waitBetweenCoats": "Espera entre capas"
      },
      "substratePrep": {
        "title": "Preparación del soporte",
        "crackTreatment": "Tratamiento de grietas",
        "dustRemoval": "Eliminación de polvo",
        "inspection": "Inspección del soporte",
        "jointTreatment": "Tratamiento de juntas",
        "maskingProtection": "Protección de áreas adyacentes",
        "maxImperfectionHint": "Umbral a partir del cual se genera una tarea de relleno",
        "maxImperfectionMm": "Imperfección máx.",
        "sanding": "Lijado",
        "surfaceCleaning": "Limpieza de superficie"
      },
      "taskFamilies": {
        "title": "Activación de familias de tareas",
        "description": "Desactivar una familia impide que estas tareas se generen en nuevos proyectos. Las tareas existentes no se eliminan.",
        "aftercare": "Aftercare / protección",
        "coating": "Capas de acabado",
        "drying": "Tiempo de secado",
        "handover": "Entrega al cliente (Handover)",
        "heavyDuty": "Heavy-Duty Sealer",
        "mesh": "Malla / tejido",
        "preparation": "Preparación del soporte",
        "presealer": "Presealer",
        "primer": "Imprimación",
        "qualityControl": "Control de calidad",
        "sealer": "Sellador"
      },
      "underfloorHeating": {
        "title": "Suelo radiante",
        "clientWarningRapidHeatUp": "Advertencia cliente calentamiento rápido",
        "controlsTitle": "Controles",
        "dailyTempCheck": "Control diario de temperatura",
        "floorSurfaceTempCheck": "Control temperatura superficie suelo antes de reinicio",
        "generateClientHandover": "Entrega de instrucciones al cliente",
        "generateMonitoring": "Tareas de control de temperatura",
        "generateProgressiveHeatUp": "Calentamiento progresivo (tareas por día)",
        "generateRestart": "Tareas de reinicio del sistema",
        "generateShutdown": "Tarea de apagado del sistema",
        "generateTasks": "Generar tareas de suelo radiante",
        "generationTitle": "Generación",
        "offDuringApplication": "Sistema apagado durante aplicación",
        "offDuringCure": "Sistema apagado durante curado",
        "requireQuestion": "Preguntar sobre suelo radiante para secciones de suelo",
        "restartAfterSealer": "Espera después de sellado antes de reinicio",
        "restartCompletionQc": "QC final tras reinicio",
        "restartMaxTemp": "Temperatura máxima",
        "restartMinDuration": "Duración mínima de subida",
        "restartRequiresValidation": "Validación requerida al final",
        "restartStartTemp": "Temperatura de inicio",
        "restartTempIncrement": "Incremento por día",
        "restartTitle": "Reinicio progresivo",
        "shutdownBeforeApplication": "Horas de apagado antes de aplicación",
        "shutdownBeforeSealer": "Horas de apagado antes de sellado",
        "shutdownTitle": "Apagado antes de aplicación",
        "warning": "Modificar los parámetros de reinicio puede afectar el rendimiento del revestimiento. Solo modifique estos valores siguiendo la documentación técnica de Mas Maya."
      },
      "waterproofing": {
        "title": "Impermeabilización",
        "bathrooms": "Membrana requerida — baños",
        "description": "El revestimiento Mas Maya es resistente al agua pero no impermeabilizante. Se requiere una membrana impermeabilizante en los siguientes casos.",
        "pools": "Membrana requerida — piscinas",
        "wetZones": "Membrana requerida — zonas húmedas",
        "wetZonesHint": "Zonas húmedas, exposición directa al agua"
      }
    },
    "roomCalculation": {
      "title": "Cálculo de habitación",
      "subtitle": "Coeficientes y parámetros para el cálculo de superficie de secciones tipo Habitación",
      "resetTitle": "Restablecer parámetros",
      "resetConfirm": "Todos los valores serán reemplazados por los valores predeterminados. Esta acción es irreversible.",
      "surfaceCoefficients": {
        "title": "Coeficientes de superficie",
        "subtitle": "Multiplicadores aplicados al área del suelo para calcular las cantidades de material",
        "walls": "Paredes",
        "wallsFormula": "superficie_paredes = suelo_m² × (coef_altura − coef_techo)",
        "wallsNote": "El coeficiente de paredes se deriva automáticamente de los coeficientes de altura y techo.",
        "floorCoeff": "Coeficiente suelo",
        "floorCoeffDesc": "Multiplicador de superficie del suelo (predeterminado = 1)",
        "ceilingCoeff": "Coeficiente techo",
        "ceilingCoeffDesc": "Multiplicador de superficie del techo (predeterminado = 1)"
      },
      "calculationMode": {
        "title": "Modo de cálculo predeterminado",
        "label": "Método de cálculo",
        "description": "Modo utilizado por defecto al crear una sección Habitación",
        "method1": "Método 1 — Coeficiente rápido",
        "method2": "Método 2 — Dimensiones exactas",
        "method3": "Método 3 — Premium ajustado"
      },
      "heightCoefficients": {
        "title": "Coeficientes de altura",
        "subtitle": "Coeficiente de superficie global = suelo_m² × coeficiente (método rápido)"
      },
      "geometricMultipliers": {
        "title": "Multiplicadores geométricos",
        "subtitle": "Factores de ajuste según el tipo de habitación",
        "colType": "Tipo",
        "colLabel": "Etiqueta",
        "colMin": "Mín",
        "colDefault": "Predeterminado",
        "colMax": "Máx"
      },
      "openingDeductions": {
        "title": "Reglas de deducción de aberturas",
        "standardDoors": "Deducir puertas estándar",
        "standardWindows": "Deducir ventanas estándar",
        "largeBays": "Deducir grandes ventanales",
        "shopfronts": "Deducir escaparates",
        "largeGlassPartitions": "Deducir grandes mamparas de vidrio",
        "thresholdLabel": "Umbral de deducción de grandes aberturas (m²)",
        "thresholdDesc": "Las aberturas que superen este umbral se deducen si la regla correspondiente está activada"
      },
      "detailAdditions": {
        "title": "Adiciones de detalle",
        "subtitle": "Porcentaje de adición para detalles arquitectónicos (retornos, nichos, vigas, casetones, pilares…)",
        "min": "Adición mínima (%)",
        "default": "Adición predeterminada (%)",
        "max": "Adición máxima (%)"
      },
      "siteConditions": {
        "title": "Multiplicadores de condición de obra",
        "subtitle": "Adiciones aplicadas según el estado de ocupación de la obra",
        "occupied": "Obra ocupada / amueblada",
        "luxury": "Obra de lujo / ultra premium",
        "minimum": "Mínimo (%)",
        "maximum": "Máximo (%)"
      },
      "heightAccess": {
        "title": "Multiplicadores de altura / acceso",
        "subtitle": "Adiciones aplicadas según la altura del techo (acceso, andamios)",
        "standardHeight": "Altura estándar (0%)",
        "noAddition": "0% — sin adición"
      },
      "specialFormulas": {
        "title": "Fórmulas geométricas especiales",
        "beams": "Vigas",
        "beamsFormula": "superficie = longitud × Σ caras visibles",
        "beamsNote": "Sumar cada cara visible (parte inferior, laterales) × longitud",
        "pillars": "Pilares",
        "pillarsFormula": "superficie = perímetro × altura",
        "pillarsNote": "Perímetro = suma de caras expuestas",
        "slopedCeilings": "Techos inclinados / en rampa",
        "slopedCeilingsFormula": "superficie real = superficie proyectada / cos(ángulo)",
        "slopedCeilingsNote": "El ángulo se mide desde la horizontal",
        "niches": "Nichos",
        "nichesFormula": "fondo + lado izquierdo + lado derecho + arriba + abajo + retornos",
        "nichesNote": "Introducir cada cara individualmente"
      }
    },
    "milestoneWorkflowDesigner": {
      "title": "Workflow Designer",
      "subtitle": "Configure el recorrido de hitos por defecto aplicado a cada nuevo proyecto.",
      "addMilestone": "Añadir hito",
      "saveMilestone": "Guardar",
      "delete": "Eliminar",
      "unsavedChanges": "Cambios sin guardar",
      "sections": {
        "identity": "Identidad",
        "triggerEngine": "Motor de activación",
        "clientVisibility": "Visibilidad del cliente",
        "approvalGate": "Puerta de aprobación",
        "payment": "Pago",
        "applicability": "Aplicabilidad",
        "photoRules": "Reglas de fotos",
        "automation": "Automatización",
        "notifications": "Notificaciones"
      },
      "fields": {
        "customTitle": "Título personalizado",
        "color": "Color",
        "icon": "Icono",
        "type": "Tipo",
        "scope": "Alcance",
        "triggerType": "Activador",
        "triggerCategories": "Categorías activadoras",
        "blocksCategories": "Categorías bloqueadas",
        "isVisibleToClient": "Visible para el cliente",
        "notifyClient": "Notificar al cliente",
        "showPhotosToClient": "Mostrar fotos al cliente",
        "showProgress": "Mostrar progreso",
        "requiresClientApproval": "Requiere aprobación del cliente",
        "paymentType": "Tipo de pago",
        "paymentPercent": "Porcentaje (%)",
        "paymentAmount": "Importe (€)",
        "appliesToRenovation": "Renovación",
        "appliesToNewBuild": "Obra nueva",
        "appliesToExternalOnly": "DIY / Externo",
        "appliesToManaged": "Gestionado Mas Maya",
        "appliesToExecuted": "Ejecutado Mas Maya",
        "requirePhotos": "Fotos requeridas",
        "minPhotos": "Fotos mínimas",
        "photosVisibleToClient": "Fotos visibles al cliente",
        "autoComplete": "Completar automáticamente",
        "autoNotifyClient": "Notificar automáticamente al cliente",
        "autoLockDependentTasks": "Bloquear tareas dependientes",
        "autoUnlockAfterApproval": "Desbloquear tras aprobación",
        "notifyWorker": "Notificar al operario",
        "notifyQm": "Notificar al QM",
        "notifyPm": "Notificar al PM"
      },
      "types": {
        "Progress": "Progreso",
        "Approval": "Aprobación",
        "Payment": "Pago"
      },
      "scopes": {
        "Project": "Proyecto",
        "Section": "Sección"
      },
      "triggerTypes": {
        "AllCategoriesCompleted": "Todas las categorías completadas",
        "FirstTaskStarted": "Primera tarea iniciada",
        "ProjectArchived": "Proyecto archivado",
        "Manual": "Manual"
      },
      "paymentTypes": {
        "None": "Ninguno",
        "Percent": "Porcentaje",
        "Fixed": "Importe fijo"
      },
      "categories": {
        "preparation": "Preparación",
        "primer": "Imprimación",
        "mesh": "Malla",
        "baseLayer": "Capa base",
        "finishingLayer": "Capa de acabado",
        "smoothing": "Alisado",
        "presealer": "Presealer",
        "sealer": "Sealer",
        "heavyDutySealer": "Heavy-Duty Sealer",
        "curing": "Curado",
        "delivery": "Entrega",
        "inspection": "Inspección",
        "handover": "Entrega al cliente",
        "custom": "Personalizado"
      },
      "executionModes": {
        "externalOnly": "DIY / Externo",
        "managed": "Gestionado Mas Maya",
        "executed": "Ejecutado Mas Maya"
      },
      "projectTypes": {
        "renovation": "Renovación",
        "newBuild": "Obra nueva"
      }
    },
    "milestoneTemplateConfig": {
      "title": "Plantillas de hitos",
      "description": "Estos ajustes definen los hitos creados automáticamente en cada nuevo proyecto Mas Maya.",
      "projectMilestones": "Hitos del proyecto",
      "sectionMilestones": "Hitos por superficie",
      "save": "Guardar",
      "saveSuccess": "Configuración guardada.",
      "saveError": "Error al guardar.",
      "unsavedWarning": "Hay cambios sin guardar.",
      "m1": {
        "label": "Proyecto iniciado",
        "hint": "Completado automáticamente al iniciar la primera tarea."
      },
      "m2": {
        "label": "Preparación completada",
        "hint": "Completado cuando todas las tareas de Preparación e Imprimación están terminadas."
      },
      "m3": {
        "label": "Aprobación de superficie",
        "hint": "Activado por sección cuando las capas de acabado están listas.",
        "requiresClientApproval": "Aprobación del cliente requerida",
        "requiresClientApprovalHint": "El cliente recibe un enlace único para aprobar o rechazar cada superficie."
      },
      "m4": {
        "label": "Protección completada",
        "hint": "Completado cuando todas las tareas de Presealer, Sealer y Heavy-Duty Sealer están terminadas."
      },
      "m5": {
        "label": "Entrega",
        "hint": "Completado automáticamente al archivar el proyecto.",
        "paymentType": "Tipo de pago",
        "paymentNone": "Ninguno",
        "paymentPercent": "Porcentaje",
        "paymentFixed": "Importe fijo",
        "paymentPercentLabel": "Porcentaje (%)",
        "paymentAmountLabel": "Importe (€)"
      }
    }
  },
  "staff": {
    "title": "Personal",
    "createButton": "Nuevo miembro del personal",
    "createTitle": "Añadir miembro del personal",
    "noData": "No se encontraron miembros del personal",
    "manager": "Responsable",
    "setManager": "Promover a responsable",
    "removeManager": "Quitar rol de responsable",
    "showInactive": "Mostrar inactivos",
    "managers": "Responsables",
    "activate": "Activar",
    "deactivate": "Desactivar",
    "columns": {
      "name": "nombre",
      "email": "correo",
      "status": "estado",
      "manager": "Encargado"
    },
    "status": {
      "active": "activo",
      "inactive": "inactivo"
    },
    "sections": {
      "profile": "perfil"
    },
    "teaching": {
      "title": "Certificación de profesor",
      "becomeTeacher": "Este empleado también es profesor",
      "certifyTitle": "Certificar como profesor",
      "editTitle": "Editar certificación",
      "editCertification": "Editar certificación"
    },
    "schedule": {
      "title": "Agenda",
      "date": "Fecha",
      "startTime": "Hora de inicio",
      "endTime": "Hora de fin",
      "type": "Tipo",
      "project": "Proyecto",
      "notes": "notas",
      "addEntry": "Añadir entrada",
      "empty": "Ninguna entrada de agenda",
      "removeTitle": "Eliminar entrada",
      "removeConfirm": "¿Seguro que deseas eliminar esta entrada de agenda?"
    },
    "scheduleType": {
      "ProjectAssignment": "Asignación de proyecto",
      "TrainingSession": "Sesión de formación",
      "Unavailable": "No disponible"
    },
    "assignedProjects": "Proyectos asignados",
    "noAssignedProjects": "Ningún proyecto asignado",
    "rolePM": "Jefe de proyecto",
    "roleBackupPM": "Jefe de proyecto suplente",
    "form": {
      "notes": "notas",
      "firstName": "Nombre",
      "firstNamePlaceholder": "John",
      "lastName": "Apellidos",
      "lastNamePlaceholder": "Doe",
      "emailRequired": "correo is obligatorio",
      "firstNameRequired": "El nombre es obligatorio",
      "lastNameRequired": "Los apellidos son obligatorios",
      "email": "correo"
    }
  },
  "structures": {
    "title": "Estructura",
    "type": "Tipo de estructura",
    "noStructure": "Ninguna estructura definida",
    "define": "Definir estructura",
    "computedSurface": "Superficie calculada",
    "computedVolume": "Volumen calculado",
    "deleteTitle": "Eliminar estructura",
    "deleteConfirm": "¿Eliminar la definición de estructura para esta sección? La superficie no se recalculará."
  },
  "calendar": {
    "title": "Calendario",
    "mode": {
      "project": "Por proyecto",
      "staff": "Por empleado"
    },
    "labels": {
      "today": "Hoy",
      "day": "Día",
      "week": "Semana",
      "month": "Mes",
      "year": "Año"
    },
    "filters": {
      "categories": "Mostrar",
      "allProjects": "Todos los proyectos",
      "selectProject": "Seleccionar un proyecto",
      "selectStaff": "Seleccionar un empleado",
      "allStatuses": "Todos los estados",
      "allStepTypes": "Todos los tipos de etapa",
      "allStaff": "Todo el personal",
      "allAccounts": "Todas las cuentas"
    },
    "categories": {
      "ProjectStep": "Etapa de proyecto",
      "DryingPeriod": "Secado",
      "CuringPeriod": "Curado",
      "Delivery": "Entrega",
      "Training": "Formación",
      "StaffSchedule": "Equipo",
      "Supervision": "Supervisión",
      "Personal": "Personal",
      "ProjectTask": "Tarea de proyecto"
    },
    "taskStatuses": {
      "Todo": "Por hacer",
      "InProgress": "En curso",
      "SubmittedForReview": "Enviada para revisión",
      "ValidatedAsTechnicallyCompliant": "Validada",
      "RejectedWithCorrectionRequired": "Rechazada — corrección requerida",
      "Blocked": "Bloqueada"
    },
    "taskCategories": {
      "Preparation": "Preparación",
      "Primer": "Imprimación",
      "Mesh": "Malla",
      "BaseLayer": "Capa base",
      "FinishingLayer": "Capa de acabado",
      "Smoothing": "Alisado",
      "Presealer": "Presealer",
      "Sealer": "Sealer",
      "HeavyDutySealer": "Sellador de alta resistencia",
      "Curing": "Curado",
      "Delivery": "Entrega",
      "Inspection": "Inspección",
      "Handover": "Entrega",
      "Custom": "Personalizado"
    },
    "taskPriorities": {
      "Low": "Low",
      "Normal": "Normal",
      "High": "Alta",
      "Critical": "Crítica"
    },
    "stepTypes": {
      "SubstratePreparation": "Preparación del soporte",
      "PrimerApplication": "Primer",
      "BaseLayer": "Capa base",
      "MeshInstallation": "Instalación de malla",
      "FinishingCoat": "Capa de acabado",
      "Smoothing": "Alisado",
      "Presealer": "Pre-sealer",
      "Sealer": "Sealer",
      "HeavyDutySealer": "Sellador de alta resistencia",
      "CuringStep": "Curado",
      "ProtectionPeriod": "Período de protección",
      "Handover": "Entrega"
    },
    "stepStatuses": {
      "Planned": "Planificado",
      "InProgress": "En curso",
      "Completed": "Completado",
      "Blocked": "Bloqueado",
      "ValidationPending": "Validación pendiente",
      "CorrectionRequired": "Corrección requerida",
      "Cancelled": "Cancelado"
    },
    "deliveryTypes": {
      "OrderConfirmed": "Pedido confirmado",
      "OrderPrepared": "Pedido preparado",
      "DeliveryExpected": "Entrega esperada",
      "DeliveryDelayed": "Entrega retrasada",
      "DeliveryCompleted": "Entregado"
    },
    "deliveryStatuses": {
      "Pending": "Pendiente",
      "InTransit": "En tránsito",
      "Delivered": "Entregado",
      "Delayed": "Retrasado",
      "Cancelled": "Cancelado"
    },
    "scheduleEntryTypes": {
      "ProjectAssignment": "Asignación de proyecto",
      "TrainingSession": "Sesión de formación",
      "Unavailable": "No disponible"
    },
    "detail": {
      "start": "Inicio",
      "end": "Fin",
      "project": "Proyecto",
      "section": "Sección",
      "stepType": "Tipo de etapa",
      "status": "Estado",
      "blocked": "Bloqueado",
      "drying": "Período de secado",
      "curing": "Período de curado",
      "deliveryType": "Tipo de entrega",
      "deliveryStatus": "Estado de la entrega",
      "trackingNumber": "Número de seguimiento",
      "carrier": "Transportista",
      "location": "Ubicación",
      "staffMember": "Miembro del personal",
      "entryType": "Tipo de entrada",
      "notes": "Notas",
      "deleteConfirm": "¿Seguro que deseas eliminar este evento? Esta acción no se puede deshacer.",
      "taskStatus": "Estado",
      "taskCategory": "Categoría",
      "taskPriority": "Prioridad",
      "assignedApplicator": "Aplicador",
      "assignedManager": "Jefe de proyecto",
      "validationRequired": "Validación requerida",
      "noPlannedDate": "Sin fecha planificada — situado en la fecha de inicio del proyecto"
    },
    "modal": {
      "createStep": "Crear etapa de proyecto",
      "editStep": "Editar etapa de proyecto",
      "createDelivery": "Crear entrega",
      "editDelivery": "Editar entrega",
      "project": "Proyecto",
      "stepType": "Tipo de etapa",
      "customTitle": "Título personalizado",
      "customTitlePlaceholder": "Dejar en blanco para usar el nombre del tipo de etapa",
      "date": "Fecha",
      "startTime": "Hora de inicio",
      "endTime": "Hora de fin",
      "dryingHours": "Secado (horas)",
      "curingHours": "Curado (horas)",
      "status": "Estado",
      "notes": "notas",
      "isBlocked": "Bloqueado",
      "blockedReason": "Motivo del bloqueo",
      "deliveryType": "Tipo de entrega",
      "deliveryStatus": "Estado",
      "expectedDate": "Fecha esperada",
      "actualDate": "Fecha de entrega real",
      "trackingNumber": "Número de seguimiento",
      "carrier": "Transportista"
    }
  },
  "supervision": {
    "title": "Supervisión",
    "tabs": {
      "comments": "Comentarios",
      "observations": "Observaciones",
      "escalations": "Escaladas",
      "history": "Historial"
    },
    "visibility": {
      "label": "Visibilidad",
      "ClientVisible": "Visible para el cliente",
      "TeamVisible": "Solo el equipo",
      "InternalOnly": "Solo interno"
    },
    "comments": {
      "empty": "Aún no hay comentarios.",
      "newPlaceholder": "Escribe un comentario…",
      "replyPlaceholder": "Escribe una respuesta…",
      "send": "Enviar",
      "reply": "Responder",
      "deleted": "[eliminado]"
    },
    "observations": {
      "empty": "Ninguna observación registrada.",
      "open": "abierta",
      "resolvedCount": "resueltas",
      "add": "Añadir observación",
      "titleLabel": "Título",
      "bodyLabel": "descripción",
      "severityLabel": "Gravedad",
      "by": "por",
      "resolved": "Resuelta",
      "resolve": "Marcar como resuelta",
      "confirmResolve": "Confirmar",
      "resolutionNote": "Nota de resolución",
      "resolveNotePlaceholder": "Describe cómo se resolvió…",
      "severity": {
        "Info": "Información",
        "Warning": "advertencia",
        "Critical": "Crítica"
      }
    },
    "escalations": {
      "empty": "Ninguna escalada.",
      "open": "abierta",
      "resolvedCount": "resueltas",
      "new": "Nueva escalada",
      "subjectLabel": "Asunto",
      "bodyLabel": "descripción",
      "submit": "Enviar",
      "by": "por",
      "assignedTo": "Asignado a",
      "resolution": "Resolución",
      "resolutionLabel": "Nota de resolución",
      "statusLabel": "nuevo estado",
      "updateStatus": "actualizar estado",
      "status": {
        "Open": "Abierta",
        "Acknowledged": "Reconocida",
        "Resolved": "Resuelta"
      }
    },
    "auditLog": {
      "empty": "Aún no hay actividad registrada.",
      "loadMore": "Cargar más",
      "actions": {
        "ProjectCreated": "creó el proyecto",
        "ProjectUpdated": "actualizó el proyecto",
        "ProjectStatusChanged": "cambió el estado del proyecto",
        "ProjectDeleted": "eliminó el proyecto",
        "StepCreated": "creó una etapa",
        "StepUpdated": "actualizó una etapa",
        "StepStatusChanged": "cambió el estado de una etapa",
        "StepDeleted": "eliminó una etapa",
        "StepBlocked": "bloqueó una etapa",
        "StepUnblocked": "desbloqueó una etapa",
        "StepValidated": "validó una etapa",
        "StepRejected": "rechazó una etapa",
        "DeliveryCreated": "creó una entrega",
        "DeliveryUpdated": "actualizó una entrega",
        "DeliveryStatusChanged": "cambió el estado de la entrega",
        "DeliveryDeleted": "eliminó una entrega",
        "ApplicatorAssigned": "asignó un aplicador",
        "ApplicatorRemoved": "retiró un aplicador",
        "TeamMemberAssigned": "asignó a un miembro del equipo",
        "TeamMemberRemoved": "retiró a un miembro del equipo",
        "BackupPmAssigned": "asignó un jefe de proyecto suplente",
        "ClientLinked": "vinculó a un cliente",
        "DocumentUploaded": "subió un documento",
        "DocumentDeleted": "eliminó un documento",
        "CommentAdded": "añadió un comentario",
        "CommentDeleted": "eliminó un comentario",
        "ObservationAdded": "registró una observación",
        "ObservationResolved": "resolvió una observación",
        "EscalationCreated": "creó una escalada",
        "EscalationAcknowledged": "reconoció una escalada",
        "EscalationResolved": "resolvió una escalada"
      }
    }
  },
  "roles": {
    "GlobalAdmin": "Superadministrador",
    "Admin": "Administrador",
    "ProjectManager": "Jefe de proyecto",
    "BackupProjectManager": "Jefe de proyecto suplente",
    "MasMayaApplicator": "Aplicador Mas Maya",
    "ReferencedInstaller": "Instalador referenciado",
    "IndividualClient": "Cliente particular",
    "ProfessionalClient": "Cliente profesional"
  },
  "userManagement": {
    "title": "Gestión de usuarios",
    "users": "usuarios",
    "searchPlaceholder": "Buscar por nombre o correo…",
    "noRoles": "Ningún rol asignado",
    "noUsers": "No se encontraron usuarios",
    "addRole": "Añadir rol",
    "columns": {
      "user": "Usuario",
      "roles": "Roles",
      "entities": "Entidades"
    },
    "removeRole": {
      "title": "Quitar rol",
      "confirm": "¿Quitar el rol {{role}} de {{user}}?"
    },
    "impersonate": "Suplantar",
    "impersonatingAs": "Conectado como {{name}}",
    "stopImpersonating": "Detener suplantación"
  },
  "shop": {
    "nav": "Tienda",
    "hero": {
      "title": "Sistemas de acabado",
      "subtitle": "Revestimientos, imprimaciones y accesorios",
      "description": "Materiales de acabado arquitectónico para artesanos exigentes."
    },
    "allProducts": "Todos los productos",
    "searchPlaceholder": "Buscar productos...",
    "noResults": "No se encontraron productos",
    "filterBy": "Filtrar por",
    "sortBy": "Ordenar por",
    "sort": {
      "nameAsc": "nombre (A–Z)",
      "priceAsc": "Precio: de menor a mayor",
      "priceDesc": "Precio: de mayor a menor"
    },
    "addToCart": "Añadir al carrito",
    "addedToCart": "Añadido al carrito",
    "viewDetails": "Ver producto",
    "backToShop": "Volver a la tienda",
    "relatedProducts": "Productos complementarios",
    "systemNote": "Estos productos forman parte de un sistema de aplicación completo.",
    "selectContact": "Seleccionar un cliente",
    "selectContactHint": "Elige un cliente para gestionar su carrito.",
    "cartFor": "Carrito de",
    "openCart": "Ver carrito",
    "cart": {
      "title": "Carrito",
      "empty": "El carrito está vacío.",
      "checkout": "Finalizar compra",
      "orderOnMasmaya": "Pedir en masmaya.com"
    },
    "qty": "Cant.",
    "details": {
      "category": "Categoría",
      "variant": "Variante",
      "color": "Color",
      "sizeWeight": "Tamaño / Peso",
      "dimensions": "Dimensiones",
      "sku": "Referencia",
      "price": "precio",
      "technical": "Información técnica"
    }
  },
  "applicatorProfiles": {
    "title": "Perfiles de aplicadores",
    "createTitle": "Crear perfil de aplicador",
    "moderateTitle": "Moderar entrada de portafolio",
    "form": {
      "contactId": "ID de contacto",
      "contactIdPlaceholder": "Pegar el UUID del contacto",
      "contactIdRequired": "El ID de contacto es obligatorio",
      "displayName": "Nombre mostrado",
      "displayNameRequired": "El nombre mostrado es obligatorio",
      "companyName": "Nombre de la empresa",
      "bio": "Biografía",
      "city": "Ciudad",
      "country": "País (código 2 letras)",
      "travelRadius": "Radio de desplazamiento (km)",
      "yearsExperience": "Años de experiencia",
      "availability": "Disponibilidad",
      "specialties": "Especialidades",
      "styleTags": "Etiquetas de estilo",
      "technicalTags": "Sistemas técnicos",
      "note": "Nota (visible solo para admin)",
      "newStatus": "Nuevo estado"
    },
    "availability": {
      "Available": "Disponible",
      "PartiallyBooked": "Parcialmente reservado",
      "Unavailable": "No disponible"
    },
    "moderation": {
      "PendingReview": "Revisión pendiente",
      "Approved": "Aprobado",
      "Rejected": "Rechazado",
      "Hidden": "Oculto",
      "Featured": "Destacado"
    },
    "currentStatus": "Estado actual:",
    "deleteConfirm": "¿Eliminar este perfil de aplicador?",
    "deleteTitle": "Eliminar perfil"
  }
}
